import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Upload: { input: globalThis.File; output: globalThis.File; }
};

export enum AcceptProjectInviteLookup {
  Id = 'ID',
  Token = 'TOKEN'
}

export type AddChildToCodeResponse = {
  __typename?: 'AddChildToCodeResponse';
  child: Maybe<Code>;
  parent: Maybe<Code>;
};

export type AiCodeSuggestion = {
  __typename?: 'AiCodeSuggestion';
  color: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isNewCode: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<AiCodeSuggestion>;
};

export type AiCodeSuggestionsResponse = {
  __typename?: 'AiCodeSuggestionsResponse';
  codes: Array<Maybe<AiCodeSuggestion>>;
  parentCodes: Array<Maybe<AiCodeSuggestion>>;
};

export type AiCodingCode = {
  __typename?: 'AiCodingCode';
  color: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  fullname: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isNewCode: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  occurrence: Maybe<Scalars['Int']['output']>;
  parent: Maybe<AiCodingCode>;
};

export type AiCodingJob = {
  __typename?: 'AiCodingJob';
  aiCodingId: Scalars['ID']['output'];
};

export type AiCodingProgressResponse = {
  __typename?: 'AiCodingProgressResponse';
  aiCodingId: Scalars['ID']['output'];
  codes: Maybe<Array<Maybe<AiCodingCode>>>;
  parentCodes: Maybe<Array<Maybe<AiCodingCode>>>;
  progressPercent: Maybe<Scalars['Int']['output']>;
  projectId: Maybe<Scalars['ID']['output']>;
  quotations: Maybe<Array<Maybe<AiCodingQuotation>>>;
  status: Maybe<Scalars['String']['output']>;
};

export type AiCodingQuotation = {
  __typename?: 'AiCodingQuotation';
  codes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  from: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isNew: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  sourceId: Maybe<Scalars['ID']['output']>;
  sourceName: Maybe<Scalars['String']['output']>;
  to: Maybe<Scalars['Int']['output']>;
};

export type AiEstimate = {
  availableTokenCount?: InputMaybe<Scalars['String']['input']>;
  timeToCompleteInMilliseconds?: InputMaybe<Scalars['String']['input']>;
  tokenCount?: InputMaybe<Scalars['String']['input']>;
};

export type AiEstimateResponse = {
  __typename?: 'AiEstimateResponse';
  availableTokenCount: Maybe<Scalars['String']['output']>;
  timeToCompleteInMilliseconds: Maybe<Scalars['String']['output']>;
  tokenCount: Maybe<Scalars['String']['output']>;
};

export type AiGenerateIntentionalCodingQuestionsProgressResponse = {
  __typename?: 'AiGenerateIntentionalCodingQuestionsProgressResponse';
  id: Maybe<Scalars['ID']['output']>;
  preparedQuestions: Maybe<Scalars['String']['output']>;
  progressPercent: Maybe<Scalars['Int']['output']>;
  questions: Maybe<Array<Maybe<AiIntentionalCodingQuestion>>>;
  status: Maybe<Scalars['String']['output']>;
};

export type AiGenerateIntentionalCodingQuestionsResponse = {
  __typename?: 'AiGenerateIntentionalCodingQuestionsResponse';
  aiGenerateIntentionalCodingQuestionsId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type AiIntentionalCodingProgressResponse = {
  __typename?: 'AiIntentionalCodingProgressResponse';
  codes: Maybe<Array<Maybe<AiCodingCode>>>;
  jobId: Maybe<Scalars['ID']['output']>;
  parentCodes: Maybe<Array<Maybe<AiCodingCode>>>;
  progressPercent: Maybe<Scalars['Int']['output']>;
  projectId: Maybe<Scalars['ID']['output']>;
  quotations: Maybe<Array<Maybe<AiCodingQuotation>>>;
  status: Maybe<Scalars['String']['output']>;
};

export type AiIntentionalCodingQuestion = {
  __typename?: 'AiIntentionalCodingQuestion';
  code: Maybe<AiCodingCode>;
  content: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type AiIntentionalCodingQuestionInput = {
  code?: InputMaybe<CreateOrUpdateCodeInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AiIntentionalCodingResponse = {
  __typename?: 'AiIntentionalCodingResponse';
  jobId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type Auth0RegisterResponse = {
  __typename?: 'Auth0RegisterResponse';
  user: Maybe<User>;
};

export type AuthenticateResponse = {
  __typename?: 'AuthenticateResponse';
  status: Maybe<UserAuthStatusType>;
  user: Maybe<User>;
};

export type CancelAiCodingResponse = {
  __typename?: 'CancelAiCodingResponse';
  aiCodingId: Scalars['ID']['output'];
};

export type Citation = {
  __typename?: 'Citation';
  html: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type Code = {
  __typename?: 'Code';
  color: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  folder: Maybe<Folder>;
  fullname: Maybe<Scalars['String']['output']>;
  groups: Maybe<Array<Maybe<Group>>>;
  id: Maybe<Scalars['ID']['output']>;
  isCategory: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  occurrence: Maybe<Scalars['Int']['output']>;
  occurrenceBySource: Maybe<Scalars['Int']['output']>;
  parent: Maybe<Code>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
};


export type CodeOccurrenceBySourceArgs = {
  id: Scalars['ID']['input'];
};

export type CodeAttachment = {
  __typename?: 'CodeAttachment';
  attachedAt: Maybe<Scalars['DateTime']['output']>;
  attachedBy: Maybe<User>;
  code: Maybe<Code>;
  detachedAt: Maybe<Scalars['DateTime']['output']>;
  detachedBy: Maybe<User>;
  quotationId: Maybe<Scalars['ID']['output']>;
};

export type Color = {
  __typename?: 'Color';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  rgb: Maybe<Scalars['String']['output']>;
  rgbBg: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
};

export type ConceptAnalysis = {
  __typename?: 'ConceptAnalysis';
  concept: Maybe<Scalars['String']['output']>;
  count: Maybe<Scalars['Int']['output']>;
  matches: Maybe<Array<Maybe<ConceptMatch>>>;
};

export type ConceptAnalysisProgressResponse = {
  __typename?: 'ConceptAnalysisProgressResponse';
  conceptAnalysisId: Scalars['ID']['output'];
  concepts: Maybe<Array<Maybe<ConceptAnalysis>>>;
  progressPercent: Maybe<Scalars['Int']['output']>;
  projectId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type ConceptAnalysisV2Response = {
  __typename?: 'ConceptAnalysisV2Response';
  conceptAnalysisId: Scalars['ID']['output'];
};

export type ConceptLocation = {
  __typename?: 'ConceptLocation';
  document: Maybe<Scalars['String']['output']>;
  range: Maybe<LocationRange>;
  text: Maybe<Scalars['String']['output']>;
};

export type ConceptMatch = {
  __typename?: 'ConceptMatch';
  count: Maybe<Scalars['Int']['output']>;
  locations: Maybe<Array<Maybe<ConceptLocation>>>;
  match: Maybe<Scalars['String']['output']>;
};

export enum ContentExtent {
  Paragraph = 'PARAGRAPH',
  Sentence = 'SENTENCE'
}

export type CreateExportResponse = {
  __typename?: 'CreateExportResponse';
  id: Maybe<Scalars['ID']['output']>;
};

export type CreateOrUpdateCodeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isNewCode?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<CreateOrUpdateParentCode>;
};

export type CreateOrUpdateParentCode = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateOrUpdateQuotationInput = {
  codes?: InputMaybe<Array<CreateOrUpdateCodeInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sourceId: Scalars['ID']['input'];
  sourceName?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Int']['input'];
};

export type CreateOrUpdateQuotationsResponse = {
  __typename?: 'CreateOrUpdateQuotationsResponse';
  codes: Maybe<Array<Maybe<Code>>>;
  parentCodes: Maybe<Array<Maybe<Code>>>;
  quotations: Maybe<Array<Maybe<Quotation>>>;
};

export type CreateSourcesCsvProgressResponse = {
  __typename?: 'CreateSourcesCsvProgressResponse';
  batchId: Maybe<Scalars['ID']['output']>;
  current: Maybe<Scalars['Int']['output']>;
  projectId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['String']['output']>;
  total: Maybe<Scalars['Int']['output']>;
};

export type CreateSourcesCsvResponse = {
  __typename?: 'CreateSourcesCsvResponse';
  batchId: Maybe<Scalars['String']['output']>;
};

export type DeleteCodeOptions = {
  moveChildrenToRoot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteCodeResponse = {
  __typename?: 'DeleteCodeResponse';
  code: Code;
  deletedChildren: Maybe<Array<Maybe<Code>>>;
  movedChildren: Maybe<Array<Maybe<Code>>>;
};

export type DuplicateCodeResponse = {
  __typename?: 'DuplicateCodeResponse';
  children: Maybe<Array<Maybe<Code>>>;
  code: Maybe<Code>;
};

export type EmbeddedFile = {
  __typename?: 'EmbeddedFile';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  file: Maybe<File>;
  id: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum EntityType {
  Code = 'code',
  Memo = 'memo',
  Source = 'source'
}

export type Error = {
  __typename?: 'Error';
  message: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
};

export type ExactMatch = {
  __typename?: 'ExactMatch';
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
};

export type ExportOptions = {
  createDownload?: InputMaybe<Scalars['Boolean']['input']>;
  throwValidationError?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<ExportVersion>;
};

export enum ExportVersion {
  Latest = 'latest',
  Legacy = 'legacy'
}

export type File = {
  __typename?: 'File';
  id: Maybe<Scalars['ID']['output']>;
  key: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  partialMd5Hash: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type Folder = {
  __typename?: 'Folder';
  childrenFolders: Maybe<Array<Maybe<Folder>>>;
  color: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  entities: Maybe<Array<Maybe<FolderEntities>>>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  parent: Maybe<Folder>;
  project: Maybe<Project>;
  type: Maybe<FolderEntityType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
};

export type FolderEntities = Code | Memo | Report | Source;

export enum FolderEntityType {
  Code = 'code',
  Memo = 'memo',
  Report = 'report',
  Source = 'source'
}

export type FragmentText = {
  __typename?: 'FragmentText';
  from: Scalars['Int']['output'];
  sentences: Array<SentenceMatch>;
  sourceId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  to: Scalars['Int']['output'];
};

export type GlobalSearchQueryHit = {
  __typename?: 'GlobalSearchQueryHit';
  fragmentTexts: Array<FragmentText>;
  searchTerm: Scalars['String']['output'];
};

export type GlobalSearchQueryInput = {
  searchTerms: Array<Scalars['String']['input']>;
  sourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Group = {
  __typename?: 'Group';
  comment: Maybe<Scalars['String']['output']>;
  contents: Maybe<Array<Maybe<Groupable>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
};

export enum GroupContentType {
  Code = 'code',
  Memo = 'memo',
  Source = 'source'
}

export type Groupable = Code | Memo | Source;

export type HelpscoutHash = {
  __typename?: 'HelpscoutHash';
  default: Scalars['String']['output'];
  es: Scalars['String']['output'];
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastname: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  rejectedAt: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<InvitationStatus>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  user: Maybe<User>;
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Retracted = 'RETRACTED'
}

export type KnownUsersToInvite = {
  aprxId: Scalars['ID']['input'];
};

export type LocationRange = {
  __typename?: 'LocationRange';
  length: Maybe<Scalars['Int']['output']>;
  start: Maybe<Scalars['Int']['output']>;
};

export type LumiveroDocumentUpload = {
  __typename?: 'LumiveroDocumentUpload';
  documentId: Scalars['ID']['output'];
  entryId: Scalars['ID']['output'];
  offsetMap: Maybe<Scalars['String']['output']>;
};

export type LumiveroUploadProjectDocumentsResponse = {
  __typename?: 'LumiveroUploadProjectDocumentsResponse';
  entries: Array<LumiveroDocumentUpload>;
};

export type Memo = {
  __typename?: 'Memo';
  bibReference: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  content: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  embeddedFile: Maybe<File>;
  embeddedFiles: Maybe<Array<Maybe<EmbeddedFile>>>;
  folder: Maybe<Folder>;
  groups: Maybe<Array<Maybe<Group>>>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['Int']['output']>;
};


export type MemoEmbeddedFileArgs = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInviteToProject: Maybe<Project>;
  addChildFolderToFolder: Maybe<Folder>;
  addChildToCode: Maybe<AddChildToCodeResponse>;
  addCodeToQuotation: Maybe<CodeAttachment>;
  addCodesToQuotation: Maybe<Array<Maybe<CodeAttachment>>>;
  addEmbeddedFileToMemo: Maybe<File>;
  addEmbeddedFileToSource: Maybe<File>;
  addToFolder: Maybe<Folder>;
  addToGroup: Maybe<Group>;
  authenticate: Maybe<AuthenticateResponse>;
  cancelAiCoding: Maybe<CancelAiCodingResponse>;
  createCode: Maybe<Code>;
  createFolder: Maybe<Folder>;
  createGroup: Maybe<Group>;
  createImportProjectPresignedUrl: Maybe<ProjectImportPresignedUrlResponse>;
  createMemo: Maybe<Memo>;
  createOrUpdateQuotations: Maybe<CreateOrUpdateQuotationsResponse>;
  createProject: Maybe<Project>;
  createProjectExport: Maybe<CreateExportResponse>;
  createProjectFromTemplate: Maybe<Project>;
  createQuotation: Maybe<Quotation>;
  createQuotations: Maybe<Array<Maybe<Quotation>>>;
  createReport: Maybe<Report>;
  createSource: Maybe<Source>;
  createSourcesFromCsvColumns: Maybe<CreateSourcesCsvResponse>;
  createSourcesFromCsvRows: Maybe<CreateSourcesCsvResponse>;
  deleteCode: Maybe<DeleteCodeResponse>;
  deleteFolder: Maybe<Folder>;
  deleteGroup: Maybe<Group>;
  deleteInviteToProject: Maybe<OkResponse>;
  deleteMemo: Maybe<Memo>;
  deleteProject: Maybe<Project>;
  deleteProjectPermanently: Maybe<Project>;
  deleteQuotation: Maybe<Quotation>;
  deleteReport: Maybe<Report>;
  deleteSource: Maybe<Source>;
  deleteTeamMemberFromProject: Maybe<Project>;
  deleteUser: Maybe<OkResponse>;
  duplicateCode: Maybe<DuplicateCodeResponse>;
  duplicateMemo: Maybe<Memo>;
  duplicateReport: Maybe<Report>;
  duplicateSource: Maybe<Source>;
  importPdfFromScholar: Maybe<Source>;
  importProjectFromAtlproj: Maybe<ProjectImport>;
  indexSearchableNodes: Maybe<OkResponse>;
  inviteToProject: Maybe<Invitation>;
  leaveProject: Maybe<OkResponse>;
  lumiveroUploadProjectDocuments: Maybe<LumiveroUploadProjectDocumentsResponse>;
  mergeCodes: Maybe<Code>;
  rejectInviteToProject: Maybe<Project>;
  removeChildFromCode: Maybe<AddChildToCodeResponse>;
  removeCodeFromQuotation: Maybe<CodeAttachment>;
  removeFromChildrenFolders: Maybe<Folder>;
  removeFromFolder: Maybe<Folder>;
  removeFromGroup: Maybe<Group>;
  resendInviteToProject: Maybe<OkResponse>;
  restoreCode: Maybe<RestoreCodeResponse>;
  restoreCodeToQuotation: Maybe<Quotation>;
  restoreFolder: Maybe<Folder>;
  restoreGroup: Maybe<Group>;
  restoreMemo: Maybe<Memo>;
  restoreProject: Maybe<Project>;
  restoreQuotation: Maybe<Quotation>;
  restoreReport: Maybe<Report>;
  restoreSource: Maybe<Source>;
  runAiCoding: Maybe<RunAiCodingResponse>;
  runProjectImport: Maybe<ProjectImport>;
  transferProjectOwnershipToTeamMember: Maybe<OkResponse>;
  updateCode: Maybe<UpdateCodeResponse>;
  updateFolder: Maybe<Folder>;
  updateGroup: Maybe<Group>;
  updateMemo: Maybe<Memo>;
  updateMemoContent: Maybe<StepsResponse>;
  updateProject: Maybe<Project>;
  updateQuotation: Maybe<Quotation>;
  updateReport: Maybe<Report>;
  updateSource: Maybe<Source>;
  updateSourceContent: Maybe<StepsResponse>;
  updateUser: Maybe<User>;
  updateUserImage: Maybe<User>;
};


export type MutationAcceptInviteToProjectArgs = {
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  lookupType?: InputMaybe<AcceptProjectInviteLookup>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddChildFolderToFolderArgs = {
  folderId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationAddChildToCodeArgs = {
  childId: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};


export type MutationAddCodeToQuotationArgs = {
  codeId: Scalars['ID']['input'];
  quotationId: Scalars['ID']['input'];
};


export type MutationAddCodesToQuotationArgs = {
  codeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  quotationId: Scalars['ID']['input'];
};


export type MutationAddEmbeddedFileToMemoArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAddEmbeddedFileToSourceArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAddToFolderArgs = {
  entityId: Scalars['ID']['input'];
  entityType?: InputMaybe<FolderEntityType>;
  folderId: Scalars['ID']['input'];
};


export type MutationAddToGroupArgs = {
  entityId: Scalars['ID']['input'];
  entityType?: InputMaybe<EntityType>;
  groupId: Scalars['ID']['input'];
};


export type MutationAuthenticateArgs = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  mayReceiveEmails: Scalars['Boolean']['input'];
};


export type MutationCancelAiCodingArgs = {
  aiCodingId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationCreateCodeArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationCreateFolderArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateGroupArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  type: GroupContentType;
};


export type MutationCreateImportProjectPresignedUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};


export type MutationCreateMemoArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateQuotationsArgs = {
  codes?: InputMaybe<Array<CreateOrUpdateCodeInput>>;
  parentCodes?: InputMaybe<Array<CreateOrUpdateCodeInput>>;
  projectId: Scalars['ID']['input'];
  quotations?: InputMaybe<Array<CreateOrUpdateQuotationInput>>;
};


export type MutationCreateProjectArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateProjectExportArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<ExportOptions>;
};


export type MutationCreateProjectFromTemplateArgs = {
  json: Scalars['String']['input'];
};


export type MutationCreateQuotationArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  containsImage?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  sourceId: Scalars['ID']['input'];
  to: Scalars['Int']['input'];
};


export type MutationCreateQuotationsArgs = {
  quotations: Array<QuotationInput>;
};


export type MutationCreateReportArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  settings?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSourceArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationCreateSourcesFromCsvColumnsArgs = {
  columnsToIgnore?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  file: Scalars['Upload']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationCreateSourcesFromCsvRowsArgs = {
  columnsToInclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  file: Scalars['Upload']['input'];
  nameColumn?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationDeleteCodeArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<DeleteCodeOptions>;
};


export type MutationDeleteFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInviteToProjectArgs = {
  id: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
};


export type MutationDeleteMemoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectPermanentlyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuotationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamMemberFromProjectArgs = {
  id: Scalars['ID']['input'];
  teamMemberId: Scalars['ID']['input'];
};


export type MutationDuplicateCodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateMemoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateSourceArgs = {
  id: Scalars['ID']['input'];
  keepCodes?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportPdfFromScholarArgs = {
  projectId: Scalars['ID']['input'];
  semanticScholarId: Scalars['String']['input'];
};


export type MutationImportProjectFromAtlprojArgs = {
  fileKey: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationIndexSearchableNodesArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationInviteToProjectArgs = {
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLeaveProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLumiveroUploadProjectDocumentsArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationMergeCodesArgs = {
  codeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectInviteToProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveChildFromCodeArgs = {
  childId: Scalars['String']['input'];
};


export type MutationRemoveCodeFromQuotationArgs = {
  codeId: Scalars['ID']['input'];
  quotationId: Scalars['ID']['input'];
};


export type MutationRemoveFromChildrenFoldersArgs = {
  folderId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationRemoveFromFolderArgs = {
  entityId: Scalars['ID']['input'];
  entityType?: InputMaybe<FolderEntityType>;
  folderId: Scalars['ID']['input'];
};


export type MutationRemoveFromGroupArgs = {
  entityId: Scalars['ID']['input'];
  entityType?: InputMaybe<EntityType>;
  groupId: Scalars['ID']['input'];
};


export type MutationResendInviteToProjectArgs = {
  id: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
};


export type MutationRestoreCodeArgs = {
  childrenToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
};


export type MutationRestoreCodeToQuotationArgs = {
  attachedAt: Scalars['String']['input'];
  attachedByUserId?: InputMaybe<Scalars['ID']['input']>;
  codeId: Scalars['ID']['input'];
  quotationId: Scalars['ID']['input'];
};


export type MutationRestoreFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreMemoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreQuotationArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRestoreReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreSourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRunAiCodingArgs = {
  aiCodingId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationRunProjectImportArgs = {
  id: Scalars['ID']['input'];
  knownUsersToInvite?: InputMaybe<Array<InputMaybe<KnownUsersToInvite>>>;
  skipInvite?: InputMaybe<Scalars['Boolean']['input']>;
  unknownUsersToInvite?: InputMaybe<Array<InputMaybe<UnknownUsersToInvite>>>;
};


export type MutationTransferProjectOwnershipToTeamMemberArgs = {
  id: Scalars['ID']['input'];
  teamMemberId: Scalars['ID']['input'];
};


export type MutationUpdateCodeArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFolderArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateGroupArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMemoArgs = {
  bibReference?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMemoContentArgs = {
  clientID: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  steps: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type MutationUpdateProjectArgs = {
  allowSupportAccess?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateQuotationArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  containsImage?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateReportArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSourceArgs = {
  bibReference?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSourceContentArgs = {
  clientID: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  steps: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type MutationUpdateUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mayReceiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateUserImageArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};

export type OkResponse = {
  __typename?: 'OkResponse';
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type PdfStyleItem = {
  __typename?: 'PdfStyleItem';
  ascent: Maybe<Scalars['Float']['output']>;
  descent: Maybe<Scalars['Float']['output']>;
  fontFamily: Scalars['String']['output'];
  fontName: Scalars['String']['output'];
  vertical: Maybe<Scalars['Boolean']['output']>;
};

export type PdfTextItem = {
  __typename?: 'PdfTextItem';
  dir: Maybe<Scalars['String']['output']>;
  fontName: Maybe<Scalars['String']['output']>;
  hasEOL: Maybe<Scalars['Boolean']['output']>;
  height: Maybe<Scalars['Float']['output']>;
  str: Scalars['String']['output'];
  transform: Maybe<Array<Scalars['Float']['output']>>;
  width: Maybe<Scalars['Float']['output']>;
};

export type PresignedPost = {
  __typename?: 'PresignedPost';
  fields: Maybe<PresignedPostFields>;
  url: Maybe<Scalars['String']['output']>;
};

export type PresignedPostFields = {
  __typename?: 'PresignedPostFields';
  bucket: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  policy: Maybe<Scalars['String']['output']>;
  xAmzAlgorithm: Maybe<Scalars['String']['output']>;
  xAmzCredential: Maybe<Scalars['String']['output']>;
  xAmzDate: Maybe<Scalars['String']['output']>;
  xAmzSignature: Maybe<Scalars['String']['output']>;
};

export type Project = {
  __typename?: 'Project';
  aiCodingJobs: Maybe<Array<Maybe<AiCodingJob>>>;
  allowSupportAccess: Maybe<Scalars['Boolean']['output']>;
  codeCount: Maybe<Scalars['Int']['output']>;
  codeFolders: Maybe<Array<Maybe<Folder>>>;
  codeGroups: Maybe<Array<Maybe<Group>>>;
  codes: Maybe<Array<Maybe<Code>>>;
  color: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  importedColors: Maybe<Array<Maybe<Color>>>;
  invitations: Maybe<Array<Maybe<Invitation>>>;
  isImported: Maybe<Scalars['Boolean']['output']>;
  memoCount: Maybe<Scalars['Int']['output']>;
  memoFolders: Maybe<Array<Maybe<Folder>>>;
  memoGroups: Maybe<Array<Maybe<Group>>>;
  memos: Maybe<Array<Maybe<Memo>>>;
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<User>;
  projectImport: Maybe<ProjectImport>;
  quotationCount: Maybe<Scalars['Int']['output']>;
  quotations: Array<Quotation>;
  recentCodeIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reportFolders: Maybe<Array<Maybe<Folder>>>;
  reports: Maybe<Array<Maybe<Report>>>;
  sourceCount: Maybe<Scalars['Int']['output']>;
  sourceFolders: Maybe<Array<Maybe<Folder>>>;
  sourceGroups: Maybe<Array<Maybe<Group>>>;
  sources: Maybe<Array<Maybe<Source>>>;
  teamMemberCount: Maybe<Scalars['Int']['output']>;
  teamMembers: Maybe<Array<Maybe<TeamMember>>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
};


export type ProjectAiCodingJobsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectTeamMemberCountArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectTeamMembersArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectExport = {
  __typename?: 'ProjectExport';
  export: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
};

export type ProjectExportProgressResponse = {
  __typename?: 'ProjectExportProgressResponse';
  current: Maybe<Scalars['Int']['output']>;
  exportLocation: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  total: Maybe<Scalars['Int']['output']>;
};

export type ProjectImport = {
  __typename?: 'ProjectImport';
  fileDownloadUrl: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  knownUsers: Maybe<Array<Maybe<ProjectImportUser>>>;
  name: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  status: Maybe<ProjectImportStatus>;
  unknownUsers: Maybe<Array<Maybe<ProjectImportUser>>>;
};

export type ProjectImportPresignedUrlResponse = {
  __typename?: 'ProjectImportPresignedUrlResponse';
  fileKey: Maybe<Scalars['String']['output']>;
  fileLocation: Maybe<Scalars['String']['output']>;
  presignedPost: Maybe<PresignedPost>;
};

export type ProjectImportProgressResponse = {
  __typename?: 'ProjectImportProgressResponse';
  current: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  projectId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['String']['output']>;
  total: Maybe<Scalars['Int']['output']>;
};

export enum ProjectImportStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  PasswordRequired = 'PASSWORD_REQUIRED',
  UsersFound = 'USERS_FOUND'
}

export type ProjectImportUser = {
  __typename?: 'ProjectImportUser';
  aprxId: Scalars['String']['output'];
  firstname: Maybe<Scalars['String']['output']>;
  fullname: Scalars['String']['output'];
  lastname: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  activeUsersBySource: Maybe<Array<Maybe<User>>>;
  aiCodeSuggestions: Maybe<AiCodeSuggestionsResponse>;
  aiCoding: Maybe<RunAiCodingResponse>;
  aiCodingCreatedCodes: Maybe<Array<Maybe<AiCodingCode>>>;
  aiCodingCreatedQuotations: Maybe<Array<Maybe<AiCodingQuotation>>>;
  aiEstimateAiCoding: Maybe<AiEstimateResponse>;
  aiEstimateIntentionalCoding: Maybe<AiEstimateResponse>;
  aiGenerateIntentionalCodingQuestions: Maybe<AiGenerateIntentionalCodingQuestionsResponse>;
  aiIntentionalCoding: Maybe<AiIntentionalCodingResponse>;
  conceptAnalysisV2: Maybe<ConceptAnalysisV2Response>;
  globalSearch: Array<GlobalSearchQueryHit>;
  group: Maybe<Group>;
  lumiveroApiToken: Scalars['String']['output'];
  memo: Maybe<Memo>;
  memoChanges: Maybe<StepsResponse>;
  project: Maybe<Project>;
  projectExport: Maybe<ProjectExport>;
  projectImport: Maybe<ProjectImport>;
  report: Maybe<Report>;
  scholarCitation: Maybe<ScholarCitationResponse>;
  scholarPaperConclusion: Maybe<ScholarPaperConclusionResponse>;
  scholarPaperSearch: Maybe<ScholarPaperSearchResponse>;
  scholarPaperSearchAiSummary: Maybe<ScholarPaperSearchAiSummary>;
  sentimentAnalysis: Maybe<SentimentAnalysisResponse>;
  source: Maybe<Source>;
  sourceChanges: Maybe<SourceChangesResponse>;
  testTemplate: Maybe<User>;
  user: Maybe<User>;
  word: Maybe<Word>;
};


export type QueryActiveUsersBySourceArgs = {
  sourceId: Scalars['ID']['input'];
};


export type QueryAiCodeSuggestionsArgs = {
  projectId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type QueryAiCodingArgs = {
  aiCodingId?: InputMaybe<Scalars['ID']['input']>;
  estimate?: InputMaybe<AiEstimate>;
  projectId: Scalars['ID']['input'];
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAiEstimateAiCodingArgs = {
  projectId: Scalars['ID']['input'];
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAiEstimateIntentionalCodingArgs = {
  projectId: Scalars['ID']['input'];
  questions?: InputMaybe<Array<AiIntentionalCodingQuestionInput>>;
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAiGenerateIntentionalCodingQuestionsArgs = {
  intentionPrompt: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryAiIntentionalCodingArgs = {
  estimate?: InputMaybe<AiEstimate>;
  projectId: Scalars['ID']['input'];
  questions?: InputMaybe<Array<AiIntentionalCodingQuestionInput>>;
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryConceptAnalysisV2Args = {
  codeGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  codeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
  sourceGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGlobalSearchArgs = {
  projectId: Scalars['ID']['input'];
  query: GlobalSearchQueryInput;
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMemoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMemoChangesArgs = {
  memoId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectExportArgs = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScholarCitationArgs = {
  semanticScholarId: Scalars['String']['input'];
};


export type QueryScholarPaperConclusionArgs = {
  abstract: Scalars['String']['input'];
  paperId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  researchQuestion: Scalars['String']['input'];
};


export type QueryScholarPaperSearchArgs = {
  createAiSummary?: InputMaybe<Scalars['Boolean']['input']>;
  filterList?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScholarPaperSearchAiSummaryArgs = {
  filterList?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
};


export type QuerySentimentAnalysisArgs = {
  content: Scalars['String']['input'];
  contentExtent?: InputMaybe<ContentExtent>;
  sentiments?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QuerySourceArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySourceChangesArgs = {
  sourceId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type QueryTestTemplateArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryWordArgs = {
  name: Scalars['String']['input'];
};

export type Quotation = {
  __typename?: 'Quotation';
  codeCount: Maybe<Scalars['Int']['output']>;
  codes: Maybe<Array<Maybe<CodeAttachment>>>;
  comment: Maybe<Scalars['String']['output']>;
  containsImage: Maybe<Scalars['Boolean']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  from: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  source: Source;
  sourceId: Maybe<Scalars['ID']['output']>;
  to: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
};

export type QuotationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  containsImage?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  sourceId: Scalars['ID']['input'];
  to: Scalars['Int']['input'];
};

export type Report = {
  __typename?: 'Report';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  folder: Maybe<Folder>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  settings: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
};

export type RestoreCodeResponse = {
  __typename?: 'RestoreCodeResponse';
  addedChildren: Maybe<Array<Maybe<Code>>>;
  code: Code;
  restoredChildren: Maybe<Array<Maybe<Code>>>;
};

export type RunAiCodingResponse = {
  __typename?: 'RunAiCodingResponse';
  aiCodingId: Scalars['ID']['output'];
  status: Maybe<Scalars['String']['output']>;
};

export type ScholarAiSummary = {
  __typename?: 'ScholarAiSummary';
  conclusion: Scalars['String']['output'];
  keyInsights: Array<Maybe<ScholarAiSummaryInsight>>;
  references: Array<Maybe<ScholarAiSummaryReference>>;
};

export enum ScholarAiSummaryEmptyReason {
  InvalidResearchQuestion = 'INVALID_RESEARCH_QUESTION',
  NotEnoughData = 'NOT_ENOUGH_DATA',
  NotRequested = 'NOT_REQUESTED'
}

export type ScholarAiSummaryInsight = {
  __typename?: 'ScholarAiSummaryInsight';
  points: Array<Maybe<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export type ScholarAiSummaryReference = {
  __typename?: 'ScholarAiSummaryReference';
  paperId: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type ScholarAuthor = {
  __typename?: 'ScholarAuthor';
  authorId: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type ScholarCitationResponse = {
  __typename?: 'ScholarCitationResponse';
  formats: Maybe<Array<Maybe<Citation>>>;
};

export type ScholarExternalIds = {
  __typename?: 'ScholarExternalIds';
  ArXiv: Maybe<Scalars['String']['output']>;
  CorpusId: Maybe<Scalars['Int']['output']>;
  DBLP: Maybe<Scalars['String']['output']>;
  DOI: Maybe<Scalars['String']['output']>;
  MAG: Maybe<Scalars['String']['output']>;
  PubMed: Maybe<Scalars['String']['output']>;
  PubMedCentral: Maybe<Scalars['String']['output']>;
};

export type ScholarPaperConclusionResponse = {
  __typename?: 'ScholarPaperConclusionResponse';
  paperConclusion: Maybe<Scalars['String']['output']>;
};

export type ScholarPaperSearchAiSummary = {
  __typename?: 'ScholarPaperSearchAiSummary';
  aiSummary: Maybe<ScholarAiSummary>;
  emptyAiSummaryReason: Maybe<ScholarAiSummaryEmptyReason>;
  filterList: Maybe<Scalars['String']['output']>;
  limit: Maybe<Scalars['Int']['output']>;
  referencedPapers: Maybe<Array<Maybe<ScholarResult>>>;
  search: Maybe<Scalars['String']['output']>;
  skip: Maybe<Scalars['Int']['output']>;
};

export type ScholarPaperSearchResponse = {
  __typename?: 'ScholarPaperSearchResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  results: Maybe<Array<Maybe<ScholarResult>>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type ScholarPdf = {
  __typename?: 'ScholarPdf';
  status: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type ScholarResult = {
  __typename?: 'ScholarResult';
  abstract: Maybe<Scalars['String']['output']>;
  authors: Maybe<Array<Maybe<ScholarAuthor>>>;
  citationCount: Scalars['Int']['output'];
  corpusId: Scalars['Int']['output'];
  externalIds: Maybe<ScholarExternalIds>;
  fieldsOfStudyNormalized: Array<Maybe<Scalars['String']['output']>>;
  influentialCitationCount: Scalars['Int']['output'];
  isOpenAccess: Maybe<Scalars['Boolean']['output']>;
  openAccessPdf: Maybe<ScholarPdf>;
  paperId: Scalars['String']['output'];
  publicationDate: Maybe<Scalars['String']['output']>;
  publicationTypes: Array<Maybe<Scalars['String']['output']>>;
  referenceCount: Scalars['Int']['output'];
  sourceId: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tldr: Maybe<Scalars['String']['output']>;
  venue: Maybe<Scalars['String']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

export type SentenceMatch = {
  __typename?: 'SentenceMatch';
  exact: Array<ExactMatch>;
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
};

export type SentimentAnalysis = {
  __typename?: 'SentimentAnalysis';
  language: Maybe<Scalars['String']['output']>;
  sentiment: Maybe<Scalars['Int']['output']>;
};

export type SentimentAnalysisProgressResponse = {
  __typename?: 'SentimentAnalysisProgressResponse';
  locations: Maybe<Array<Maybe<SentimentLocation>>>;
  progressPercent: Maybe<Scalars['Int']['output']>;
  sentimentAnalysisId: Scalars['ID']['output'];
  status: Maybe<Scalars['String']['output']>;
};

export type SentimentAnalysisResponse = {
  __typename?: 'SentimentAnalysisResponse';
  sentimentAnalysisId: Scalars['ID']['output'];
};

export type SentimentLocation = {
  __typename?: 'SentimentLocation';
  analysis: Maybe<SentimentAnalysis>;
  range: Maybe<LocationRange>;
};

export type Source = {
  __typename?: 'Source';
  bibReference: Maybe<Scalars['String']['output']>;
  codes: Array<Code>;
  comment: Maybe<Scalars['String']['output']>;
  content: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  embeddedFile: Maybe<File>;
  embeddedFiles: Maybe<Array<Maybe<EmbeddedFile>>>;
  file: Maybe<File>;
  fileLocation: Maybe<Scalars['String']['output']>;
  fileType: Maybe<Scalars['String']['output']>;
  folder: Maybe<Folder>;
  groups: Maybe<Array<Maybe<Group>>>;
  id: Maybe<Scalars['ID']['output']>;
  isEmpty: Maybe<Scalars['Boolean']['output']>;
  lastOpenedAt: Maybe<Scalars['DateTime']['output']>;
  name: Maybe<Scalars['String']['output']>;
  pdfPages: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  plutFile: Maybe<File>;
  quotationCount: Maybe<Scalars['Int']['output']>;
  quotations: Maybe<Array<Maybe<Quotation>>>;
  quotes: Maybe<Scalars['Int']['output']>;
  semanticScholarPaperId: Maybe<Scalars['String']['output']>;
  storedPdfPagesCount: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  uuid: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['Int']['output']>;
};


export type SourceEmbeddedFileArgs = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
};


export type SourcePdfPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SourceChangesResponse = {
  __typename?: 'SourceChangesResponse';
  clientIDs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quotations: Maybe<Array<Maybe<Quotation>>>;
  steps: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type StepsResponse = {
  __typename?: 'StepsResponse';
  clientIDs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  steps: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  aiCodingProgress: Maybe<AiCodingProgressResponse>;
  aiGenerateIntentionalCodingQuestionsProgress: Maybe<AiGenerateIntentionalCodingQuestionsProgressResponse>;
  aiIntentionalCodingProgress: Maybe<AiIntentionalCodingProgressResponse>;
  conceptAnalysisProgress: Maybe<ConceptAnalysisProgressResponse>;
  createSourcesCsvProgress: Maybe<CreateSourcesCsvProgressResponse>;
  projectCreated: Maybe<Project>;
  projectExportProgress: Maybe<ProjectExportProgressResponse>;
  projectImportProgress: Maybe<ProjectImportProgressResponse>;
  scholarPaperSearchAiSummary: Maybe<ScholarPaperSearchAiSummary>;
  sentimentAnalysisProgress: Maybe<SentimentAnalysisProgressResponse>;
  sourcesCreated: Maybe<Array<Maybe<Source>>>;
};


export type SubscriptionAiCodingProgressArgs = {
  aiCodingId: Scalars['ID']['input'];
};


export type SubscriptionAiGenerateIntentionalCodingQuestionsProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionAiIntentionalCodingProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionConceptAnalysisProgressArgs = {
  conceptAnalysisId: Scalars['ID']['input'];
};


export type SubscriptionCreateSourcesCsvProgressArgs = {
  batchId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type SubscriptionProjectExportProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionProjectImportProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionScholarPaperSearchAiSummaryArgs = {
  filterList?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
};


export type SubscriptionSentimentAnalysisProgressArgs = {
  sentimentAnalysisId: Scalars['ID']['input'];
};


export type SubscriptionSourcesCreatedArgs = {
  projectId: Scalars['ID']['input'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  deactivatedAt: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastActiveAt: Maybe<Scalars['DateTime']['output']>;
  leftAt: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<TeamMemberStatus>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<User>;
  user: Maybe<User>;
};

export enum TeamMemberStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Left = 'LEFT',
  Removed = 'REMOVED'
}

export type UnknownUsersToInvite = {
  aprxId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCodeResponse = {
  __typename?: 'UpdateCodeResponse';
  children: Maybe<Array<Maybe<Code>>>;
  code: Code;
};

export type User = {
  __typename?: 'User';
  auth0Id: Maybe<Scalars['String']['output']>;
  cbCustomerId: Maybe<Scalars['String']['output']>;
  confirmedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Maybe<Scalars['String']['output']>;
  fullname: Maybe<Scalars['String']['output']>;
  helpscoutHashes: Maybe<HelpscoutHash>;
  id: Maybe<Scalars['ID']['output']>;
  image: Maybe<Scalars['String']['output']>;
  imageIsGravatar: Maybe<Scalars['Boolean']['output']>;
  isPlaceholder: Maybe<Scalars['Boolean']['output']>;
  isSupportAgent: Maybe<Scalars['Boolean']['output']>;
  lastLogin: Maybe<Scalars['DateTime']['output']>;
  lastname: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  mayReceiveEmails: Maybe<Scalars['Boolean']['output']>;
  projects: Maybe<Array<Maybe<Project>>>;
  projectsInvited: Maybe<Array<Maybe<Project>>>;
  projectsJoined: Maybe<Array<Maybe<Project>>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  uuid: Maybe<Scalars['String']['output']>;
  wasInBeta: Maybe<Scalars['Boolean']['output']>;
};

export enum UserAuthStatusType {
  Existing = 'EXISTING',
  New = 'NEW',
  Updated = 'UPDATED'
}

export type Word = {
  __typename?: 'Word';
  category: Maybe<WordCategory>;
  name: Maybe<Scalars['String']['output']>;
  synonyms: Maybe<Array<Maybe<Word>>>;
};

export enum WordCategory {
  A = 'a',
  N = 'n',
  R = 'r',
  S = 's',
  V = 'v'
}

export type AiCodeSuggestionDefaultFragment = { __typename?: 'AiCodeSuggestion', id: string, color: string | null, isNewCode: boolean, name: string, comment: string | null, parent: { __typename?: 'AiCodeSuggestion', id: string } | null };

export type AiCodingCodeDefaultFragment = { __typename?: 'AiCodingCode', id: string, color: string | null, isNewCode: boolean | null, fullname: string | null, name: string | null, occurrence: number | null, comment: string | null, parent: { __typename?: 'AiCodingCode', id: string, name: string | null } | null };

export type AiCodingQuotationDefaultFragment = { __typename?: 'AiCodingQuotation', sourceName: string | null, sourceId: string | null, from: number | null, to: number | null, id: string, codes: Array<string | null> | null, isNew: boolean | null, name: string | null };

export type CodeDefaultFragment = { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null };

export type CodeGroupsFragment = { __typename?: 'Code', groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null };

export type EmbeddedFileDefaultFragment = { __typename?: 'EmbeddedFile', id: string | null, createdAt: any | null, updatedAt: any | null, deletedAt: any | null, file: { __typename?: 'File', id: string | null, type: string | null, location: string | null, key: string | null } | null };

export type FileDefaultFragment = { __typename?: 'File', id: string | null, type: string | null, location: string | null, key: string | null };

export type FolderDefaultFragment = { __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null };

export type GroupContentsFragment = { __typename?: 'Group', id: string | null, contents: Array<{ __typename: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, parent: { __typename?: 'Code', id: string | null } | null } | { __typename: 'Memo', id: string | null, name: string | null, comment: string | null } | { __typename: 'Source', id: string | null, name: string | null, comment: string | null } | null> | null };

export type GroupDefaultFragment = { __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null };

export type InvitationFragment = { __typename?: 'Invitation', id: string | null, email: string | null, firstname: string | null, lastname: string | null, user: { __typename?: 'User', id: string | null, image: string | null, fullname: string | null } | null };

export type MemoDefaultFragment = { __typename?: 'Memo', id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null };

export type ProjectCodeFragment = { __typename?: 'Code', comment: string | null, createdAt: any | null, updatedAt: any | null, id: string | null, name: string | null, fullname: string | null, color: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null };

export type ProjectDefaultFragment = { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, allowSupportAccess: boolean | null, recentCodeIds: Array<string | null> | null, isImported: boolean | null, activeTeamMemberCount: number | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null, sources: Array<{ __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, codes: Array<{ __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null }>, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null> | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, source: { __typename?: 'Source', id: string | null, name: string | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null }, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null }>, codes: Array<{ __typename?: 'Code', comment: string | null, createdAt: any | null, updatedAt: any | null, occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null> | null, memos: Array<{ __typename?: 'Memo', id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codeFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, sourceFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, memoFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, reportFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, occurrence: number | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | { __typename?: 'Memo' } | { __typename?: 'Source' } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code' } | { __typename?: 'Memo' } | { __typename?: 'Source', id: string | null, name: string | null, comment: string | null } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code' } | { __typename?: 'Memo', id: string | null, name: string | null, comment: string | null } | { __typename?: 'Source' } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, reports: Array<{ __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null, createdAt: any | null, updatedAt: any | null, folder: { __typename?: 'Folder', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, importedTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, leftTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, importedColors: Array<{ __typename?: 'Color', id: string | null, name: string | null, rgb: string | null } | null> | null, activeAiCoding: Array<{ __typename?: 'AiCodingJob', aiCodingId: string } | null> | null, recentlyCompletedAiCoding: Array<{ __typename?: 'AiCodingJob', aiCodingId: string } | null> | null, invitations: Array<{ __typename?: 'Invitation', id: string | null, email: string | null, firstname: string | null, lastname: string | null, user: { __typename?: 'User', id: string | null, image: string | null, fullname: string | null } | null } | null> | null };

export type ProjectFullIdsFragment = { __typename?: 'Project', id: string | null, sources: Array<{ __typename?: 'Source', id: string | null, pdfPages: Array<string | null> | null, fileLocation: string | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, codes: Array<{ __typename?: 'CodeAttachment', code: { __typename?: 'Code', id: string | null } | null } | null> | null } | null> | null, file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null, embeddedFiles: Array<{ __typename?: 'EmbeddedFile', file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codes: Array<{ __typename?: 'Code', id: string | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, memos: Array<{ __typename?: 'Memo', id: string | null, embeddedFiles: Array<{ __typename?: 'EmbeddedFile', file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, reports: Array<{ __typename?: 'Report', id: string | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, invitations: Array<{ __typename?: 'Invitation', id: string | null } | null> | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null } | null> | null, leftTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null } | null> | null, importedColors: Array<{ __typename?: 'Color', id: string | null } | null> | null };

export type ProjectInvitationsFragment = { __typename?: 'Project', invitations: Array<{ __typename?: 'Invitation', id: string | null, email: string | null, firstname: string | null, lastname: string | null, user: { __typename?: 'User', id: string | null, image: string | null, fullname: string | null } | null } | null> | null };

export type ProjectOverviewInfoFragment = { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null };

export type QuotationCodeUpdateFragment = { __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null };

export type QuotationDefaultFragment = { __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null };

export type ReportDefaultFragment = { __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null, createdAt: any | null, updatedAt: any | null, folder: { __typename?: 'Folder', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null };

export type ScholarResultDefaultFragment = { __typename?: 'ScholarResult', paperId: string, sourceId: string | null, corpusId: number, title: string, abstract: string | null, tldr: string | null, publicationDate: string | null, year: number | null, referenceCount: number, citationCount: number, influentialCitationCount: number, fieldsOfStudyNormalized: Array<string | null>, publicationTypes: Array<string | null>, isOpenAccess: boolean | null, venue: string | null, openAccessPdf: { __typename?: 'ScholarPdf', url: string | null } | null, authors: Array<{ __typename?: 'ScholarAuthor', authorId: string | null, name: string | null } | null> | null, externalIds: { __typename?: 'ScholarExternalIds', DOI: string | null, PubMed: string | null } | null };

export type SourceDefaultFragment = { __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null };

export type SourceQuotationUpdateFragment = { __typename?: 'Source', id: string | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null };

export type UserActivityFragment = { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null };

export type UserBaseFragment = { __typename?: 'User', id: string | null, firstname: string | null, lastname: string | null, fullname: string | null, email: string | null, locale: string | null, image: string | null, imageIsGravatar: boolean | null, createdAt: any | null, confirmedAt: any | null, mayReceiveEmails: boolean | null, isSupportAgent: boolean | null, helpscoutHashes: { __typename?: 'HelpscoutHash', default: string, es: string } | null };

export type UserForExportFragment = { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null };

export type UserInTeamFragment = { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null };

export type AcceptInviteToProjectMutationVariables = Exact<{
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  lookupType: AcceptProjectInviteLookup;
}>;


export type AcceptInviteToProjectMutation = { __typename?: 'Mutation', acceptInviteToProject: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null };

export type AddChildToCodeMutationVariables = Exact<{
  parentId: Scalars['String']['input'];
  childId: Scalars['String']['input'];
}>;


export type AddChildToCodeMutation = { __typename?: 'Mutation', addChildToCode: { __typename?: 'AddChildToCodeResponse', parent: { __typename?: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, name: string | null } | null> | null, parent: { __typename?: 'Code', id: string | null } | null, folder: { __typename?: 'Folder', id: string | null } | null } | null, child: { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, comment: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, name: string | null } | null> | null, parent: { __typename?: 'Code', id: string | null } | null, folder: { __typename?: 'Folder', id: string | null } | null } | null } | null };

export type AddCodeToFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
}>;


export type AddCodeToFolderMutation = { __typename?: 'Mutation', addToFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type AddCodeToGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type AddCodeToGroupMutation = { __typename?: 'Mutation', addToGroup: { __typename?: 'Group', id: string | null, name: string | null } | null };

export type AddCodeToQuotationMutationVariables = Exact<{
  codeId: Scalars['ID']['input'];
  quotationId: Scalars['ID']['input'];
}>;


export type AddCodeToQuotationMutation = { __typename?: 'Mutation', addCodeToQuotation: { __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null };

export type AddCodesToQuotationMutationVariables = Exact<{
  codeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quotationId: Scalars['ID']['input'];
}>;


export type AddCodesToQuotationMutation = { __typename?: 'Mutation', addCodesToQuotation: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null };

export type AddEmbeddedFileToMemoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type AddEmbeddedFileToMemoMutation = { __typename?: 'Mutation', addEmbeddedFileToMemo: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null };

export type AddEmbeddedFileToSourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type AddEmbeddedFileToSourceMutation = { __typename?: 'Mutation', addEmbeddedFileToSource: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null };

export type AddMemoToFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
}>;


export type AddMemoToFolderMutation = { __typename?: 'Mutation', addToFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type AddMemoToGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type AddMemoToGroupMutation = { __typename?: 'Mutation', addToGroup: { __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null };

export type AddReportToFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
}>;


export type AddReportToFolderMutation = { __typename?: 'Mutation', addToFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type AddSourceToFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
}>;


export type AddSourceToFolderMutation = { __typename?: 'Mutation', addToFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type AddSourceToGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type AddSourceToGroupMutation = { __typename?: 'Mutation', addToGroup: { __typename?: 'Group', id: string | null, name: string | null } | null };

export type AddChildFolderToFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
}>;


export type AddChildFolderToFolderMutation = { __typename?: 'Mutation', addChildFolderToFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type AuthenticateMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  mayReceiveEmails: Scalars['Boolean']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate: { __typename?: 'AuthenticateResponse', status: UserAuthStatusType | null, user: { __typename?: 'User', id: string | null, firstname: string | null, lastname: string | null, fullname: string | null, email: string | null, locale: string | null, image: string | null, imageIsGravatar: boolean | null, createdAt: any | null, confirmedAt: any | null, mayReceiveEmails: boolean | null, isSupportAgent: boolean | null, helpscoutHashes: { __typename?: 'HelpscoutHash', default: string, es: string } | null } | null } | null };

export type CancelAiCodingMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  aiCodingId: Scalars['ID']['input'];
}>;


export type CancelAiCodingMutation = { __typename?: 'Mutation', cancelAiCoding: { __typename?: 'CancelAiCodingResponse', aiCodingId: string } | null };

export type ConceptAnalysisV2QueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  codeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  codeGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sourceGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ConceptAnalysisV2Query = { __typename?: 'Query', conceptAnalysisV2: { __typename?: 'ConceptAnalysisV2Response', conceptAnalysisId: string } | null };

export type CreateCodeMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateCodeMutation = { __typename?: 'Mutation', createCode: { __typename?: 'Code', createdAt: any | null, updatedAt: any | null, isCategory: boolean | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, folder: { __typename?: 'Folder', id: string | null } | null } | null };

export type CreateFolderMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFolderMutation = { __typename?: 'Mutation', createFolder: { __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null };

export type CreateGroupMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  type: GroupContentType;
  name: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, contents: Array<{ __typename: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, parent: { __typename?: 'Code', id: string | null } | null } | { __typename: 'Memo', id: string | null, name: string | null, comment: string | null } | { __typename: 'Source', id: string | null, name: string | null, comment: string | null } | null> | null } | null };

export type CreateImportProjectPresignedUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
}>;


export type CreateImportProjectPresignedUrlMutation = { __typename?: 'Mutation', createImportProjectPresignedUrl: { __typename?: 'ProjectImportPresignedUrlResponse', fileKey: string | null, fileLocation: string | null, presignedPost: { __typename?: 'PresignedPost', url: string | null, fields: { __typename?: 'PresignedPostFields', key: string | null, bucket: string | null, xAmzAlgorithm: string | null, xAmzCredential: string | null, xAmzDate: string | null, policy: string | null, xAmzSignature: string | null } | null } | null } | null };

export type CreateMemoMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMemoMutation = { __typename?: 'Mutation', createMemo: { __typename?: 'Memo', id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null };

export type CreateOrUpdateQuotationsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  codes: Array<CreateOrUpdateCodeInput> | CreateOrUpdateCodeInput;
  parentCodes: Array<CreateOrUpdateCodeInput> | CreateOrUpdateCodeInput;
  quotations: Array<CreateOrUpdateQuotationInput> | CreateOrUpdateQuotationInput;
}>;


export type CreateOrUpdateQuotationsMutation = { __typename?: 'Mutation', createOrUpdateQuotations: { __typename?: 'CreateOrUpdateQuotationsResponse', codes: Array<{ __typename?: 'Code', createdAt: any | null, updatedAt: any | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, parentCodes: Array<{ __typename?: 'Code', createdAt: any | null, updatedAt: any | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, quotations: Array<{ __typename?: 'Quotation', sourceId: string | null, deletedAt: any | null, id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null };

export type CreateProjectExportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  options?: InputMaybe<ExportOptions>;
}>;


export type CreateProjectExportMutation = { __typename?: 'Mutation', createProjectExport: { __typename?: 'CreateExportResponse', id: string | null } | null };

export type CreateProjectFromTemplateMutationVariables = Exact<{
  json: Scalars['String']['input'];
}>;


export type CreateProjectFromTemplateMutation = { __typename?: 'Mutation', createProjectFromTemplate: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, codeCount: number | null, memoCount: number | null, quotationCount: number | null, sourceCount: number | null, updatedAt: any | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null };

export type CreateQuotationMutationVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  containsImage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateQuotationMutation = { __typename?: 'Mutation', createQuotation: { __typename?: 'Quotation', id: string | null, name: string | null, from: number | null, to: number | null, comment: string | null, containsImage: boolean | null, deletedAt: any | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', id: string | null, name: string | null, color: string | null } | null } | null> | null } | null };

export type CreateQuotationsMutationVariables = Exact<{
  quotations: Array<QuotationInput> | QuotationInput;
}>;


export type CreateQuotationsMutation = { __typename?: 'Mutation', createQuotations: Array<{ __typename?: 'Quotation', sourceId: string | null, id: string | null, name: string | null, from: number | null, to: number | null, comment: string | null, containsImage: boolean | null, deletedAt: any | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', id: string | null, name: string | null, color: string | null } | null } | null> | null } | null> | null };

export type CreateReportMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null, createdAt: any | null, updatedAt: any | null, folder: { __typename?: 'Folder', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null };

export type CreateSourceMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type CreateSourceMutation = { __typename?: 'Mutation', createSource: { __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null };

export type CreateSourcesFromCsvColumnsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  columnsToIgnore?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateSourcesFromCsvColumnsMutation = { __typename?: 'Mutation', createSourcesFromCsvColumns: { __typename?: 'CreateSourcesCsvResponse', batchId: string | null } | null };

export type CreateSourcesFromCsvRowsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  nameColumn?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSourcesFromCsvRowsMutation = { __typename?: 'Mutation', createSourcesFromCsvRows: { __typename?: 'CreateSourcesCsvResponse', batchId: string | null } | null };

export type DeleteCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  options?: InputMaybe<DeleteCodeOptions>;
}>;


export type DeleteCodeMutation = { __typename?: 'Mutation', deleteCode: { __typename?: 'DeleteCodeResponse', code: { __typename?: 'Code', id: string | null }, deletedChildren: Array<{ __typename?: 'Code', id: string | null } | null> | null, movedChildren: Array<{ __typename?: 'Code', id: string | null, fullname: string | null, parent: { __typename?: 'Code', id: string | null } | null } | null> | null } | null };

export type DeleteFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFolderMutation = { __typename?: 'Mutation', deleteFolder: { __typename?: 'Folder', id: string | null } | null };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup: { __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null };

export type DeleteInviteToProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
}>;


export type DeleteInviteToProjectMutation = { __typename?: 'Mutation', deleteInviteToProject: { __typename?: 'OkResponse', ok: boolean | null } | null };

export type DeleteMemoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMemoMutation = { __typename?: 'Mutation', deleteMemo: { __typename?: 'Memo', id: string | null } | null };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'Project', id: string | null } | null };

export type DeleteProjectPermanentlyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectPermanentlyMutation = { __typename?: 'Mutation', deleteProjectPermanently: { __typename?: 'Project', id: string | null } | null };

export type DeleteQuotationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteQuotationMutation = { __typename?: 'Mutation', deleteQuotation: { __typename?: 'Quotation', id: string | null } | null };

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: { __typename?: 'Report', id: string | null, name: string | null, comment: string | null, type: string | null, settings: string | null, deletedAt: any | null } | null };

export type DeleteSourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSourceMutation = { __typename?: 'Mutation', deleteSource: { __typename?: 'Source', id: string | null } | null };

export type DeleteTeamMemberFromProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  teamMemberId: Scalars['ID']['input'];
}>;


export type DeleteTeamMemberFromProjectMutation = { __typename?: 'Mutation', deleteTeamMemberFromProject: { __typename?: 'Project', id: string | null, activeTeamMemberCount: number | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, leftTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null } | null };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'OkResponse', ok: boolean | null } | null };

export type DuplicateCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateCodeMutation = { __typename?: 'Mutation', duplicateCode: { __typename?: 'DuplicateCodeResponse', code: { __typename?: 'Code', createdAt: any | null, updatedAt: any | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null, children: Array<{ __typename?: 'Code', createdAt: any | null, updatedAt: any | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null> | null } | null };

export type DuplicateMemoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateMemoMutation = { __typename?: 'Mutation', duplicateMemo: { __typename?: 'Memo', content: string | null, version: number | null, id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null };

export type DuplicateReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateReportMutation = { __typename?: 'Mutation', duplicateReport: { __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null, createdAt: any | null, updatedAt: any | null, folder: { __typename?: 'Folder', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null };

export type DuplicateSourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateSourceMutation = { __typename?: 'Mutation', duplicateSource: { __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null };

export type DuplicateSourceWithCodesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateSourceWithCodesMutation = { __typename?: 'Mutation', duplicateSource: { __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null };

export type ImportPdfFromScholarMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  semanticScholarId: Scalars['String']['input'];
}>;


export type ImportPdfFromScholarMutation = { __typename?: 'Mutation', importPdfFromScholar: { __typename?: 'Source', semanticScholarPaperId: string | null, id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null };

export type ImportProjectFromAtlprojMutationVariables = Exact<{
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
}>;


export type ImportProjectFromAtlprojMutation = { __typename?: 'Mutation', importProjectFromAtlproj: { __typename?: 'ProjectImport', id: string | null, status: ProjectImportStatus | null, name: string | null, project: { __typename?: 'Project', id: string | null } | null, knownUsers: Array<{ __typename?: 'ProjectImportUser', aprxId: string, fullname: string, firstname: string | null, lastname: string | null } | null> | null, unknownUsers: Array<{ __typename?: 'ProjectImportUser', aprxId: string, fullname: string } | null> | null } | null };

export type GlobalSearchIndexMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GlobalSearchIndexMutation = { __typename?: 'Mutation', indexSearchableNodes: { __typename?: 'OkResponse', ok: boolean | null } | null };

export type InviteToProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteToProjectMutation = { __typename?: 'Mutation', inviteToProject: { __typename?: 'Invitation', id: string | null, email: string | null, firstname: string | null, lastname: string | null, user: { __typename?: 'User', id: string | null, image: string | null, fullname: string | null } | null } | null };

export type LeaveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LeaveProjectMutation = { __typename?: 'Mutation', leaveProject: { __typename?: 'OkResponse', ok: boolean | null } | null };

export type MergeCodesMutationVariables = Exact<{
  codeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type MergeCodesMutation = { __typename?: 'Mutation', mergeCodes: { __typename?: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, isCategory: boolean | null, parent: { __typename?: 'Code', id: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null };

export type RejectInviteToProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RejectInviteToProjectMutation = { __typename?: 'Mutation', rejectInviteToProject: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null };

export type RemoveChildFromCodeMutationVariables = Exact<{
  childId: Scalars['String']['input'];
}>;


export type RemoveChildFromCodeMutation = { __typename?: 'Mutation', removeChildFromCode: { __typename?: 'AddChildToCodeResponse', parent: { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, comment: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, name: string | null } | null> | null, parent: { __typename?: 'Code', id: string | null } | null } | null, child: { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, comment: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, name: string | null } | null> | null, parent: { __typename?: 'Code', id: string | null } | null } | null } | null };

export type RemoveCodeFromFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
}>;


export type RemoveCodeFromFolderMutation = { __typename?: 'Mutation', removeFromFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type RemoveCodeFromGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type RemoveCodeFromGroupMutation = { __typename?: 'Mutation', removeFromGroup: { __typename?: 'Group', id: string | null, name: string | null } | null };

export type RemoveCodeFromQuotationMutationVariables = Exact<{
  codeId: Scalars['ID']['input'];
  quotationId: Scalars['ID']['input'];
}>;


export type RemoveCodeFromQuotationMutation = { __typename?: 'Mutation', removeCodeFromQuotation: { __typename?: 'CodeAttachment', quotationId: string | null, code: { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null };

export type RemoveFromChildrenFoldersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
}>;


export type RemoveFromChildrenFoldersMutation = { __typename?: 'Mutation', removeFromChildrenFolders: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type RemoveMemoFromFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
}>;


export type RemoveMemoFromFolderMutation = { __typename?: 'Mutation', removeFromFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type RemoveMemoFromGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type RemoveMemoFromGroupMutation = { __typename?: 'Mutation', removeFromGroup: { __typename?: 'Group', id: string | null, name: string | null } | null };

export type RemoveReportFromFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
}>;


export type RemoveReportFromFolderMutation = { __typename?: 'Mutation', removeFromFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type RemoveSourceFromFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
}>;


export type RemoveSourceFromFolderMutation = { __typename?: 'Mutation', removeFromFolder: { __typename?: 'Folder', id: string | null, name: string | null } | null };

export type RemoveSourceFromGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type RemoveSourceFromGroupMutation = { __typename?: 'Mutation', removeFromGroup: { __typename?: 'Group', id: string | null, name: string | null } | null };

export type ResendInviteToProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
}>;


export type ResendInviteToProjectMutation = { __typename?: 'Mutation', resendInviteToProject: { __typename?: 'OkResponse', ok: boolean | null } | null };

export type RestoreCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  childrenToAdd?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RestoreCodeMutation = { __typename?: 'Mutation', restoreCode: { __typename?: 'RestoreCodeResponse', code: { __typename?: 'Code', createdAt: any | null, updatedAt: any | null, occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null }, restoredChildren: Array<{ __typename?: 'Code', createdAt: any | null, updatedAt: any | null, occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null> | null, addedChildren: Array<{ __typename?: 'Code', id: string | null, parent: { __typename?: 'Code', id: string | null } | null } | null> | null } | null };

export type RestoreCodeToQuotationMutationVariables = Exact<{
  codeId: Scalars['ID']['input'];
  quotationId: Scalars['ID']['input'];
  attachedAt: Scalars['String']['input'];
  attachedByUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RestoreCodeToQuotationMutation = { __typename?: 'Mutation', restoreCodeToQuotation: { __typename?: 'Quotation', id: string | null, updatedAt: any | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null };

export type RestoreFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreFolderMutation = { __typename?: 'Mutation', restoreFolder: { __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null };

export type RestoreGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreGroupMutation = { __typename?: 'Mutation', restoreGroup: { __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, contents: Array<{ __typename: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, parent: { __typename?: 'Code', id: string | null } | null } | { __typename: 'Memo', id: string | null, name: string | null, comment: string | null } | { __typename: 'Source', id: string | null, name: string | null, comment: string | null } | null> | null } | null };

export type RestoreMemoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreMemoMutation = { __typename?: 'Mutation', restoreMemo: { __typename?: 'Memo', id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null };

export type RestoreProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreProjectMutation = { __typename?: 'Mutation', restoreProject: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, allowSupportAccess: boolean | null, recentCodeIds: Array<string | null> | null, isImported: boolean | null, createdAt: any | null, updatedAt: any | null, activeTeamMemberCount: number | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, sources: Array<{ __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, codes: Array<{ __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null }>, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null> | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, source: { __typename?: 'Source', id: string | null, name: string | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null }, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null }>, codes: Array<{ __typename?: 'Code', comment: string | null, createdAt: any | null, updatedAt: any | null, occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null> | null, memos: Array<{ __typename?: 'Memo', id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codeFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, sourceFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, memoFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, reportFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, occurrence: number | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | { __typename?: 'Memo' } | { __typename?: 'Source' } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code' } | { __typename?: 'Memo' } | { __typename?: 'Source', id: string | null, name: string | null, comment: string | null } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code' } | { __typename?: 'Memo', id: string | null, name: string | null, comment: string | null } | { __typename?: 'Source' } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, reports: Array<{ __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null, createdAt: any | null, updatedAt: any | null, folder: { __typename?: 'Folder', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, importedTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, leftTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, importedColors: Array<{ __typename?: 'Color', id: string | null, name: string | null, rgb: string | null } | null> | null, activeAiCoding: Array<{ __typename?: 'AiCodingJob', aiCodingId: string } | null> | null, recentlyCompletedAiCoding: Array<{ __typename?: 'AiCodingJob', aiCodingId: string } | null> | null, invitations: Array<{ __typename?: 'Invitation', id: string | null, email: string | null, firstname: string | null, lastname: string | null, user: { __typename?: 'User', id: string | null, image: string | null, fullname: string | null } | null } | null> | null } | null };

export type RestoreQuotationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RestoreQuotationMutation = { __typename?: 'Mutation', restoreQuotation: { __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null };

export type RestoreReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreReportMutation = { __typename?: 'Mutation', restoreReport: { __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null, createdAt: any | null, updatedAt: any | null, folder: { __typename?: 'Folder', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null };

export type RestoreSourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreSourceMutation = { __typename?: 'Mutation', restoreSource: { __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null };

export type RunProjectImportWithInvitesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  knownUsersToInvite: Array<InputMaybe<KnownUsersToInvite>> | InputMaybe<KnownUsersToInvite>;
  unknownUsersToInvite: Array<InputMaybe<UnknownUsersToInvite>> | InputMaybe<UnknownUsersToInvite>;
}>;


export type RunProjectImportWithInvitesMutation = { __typename?: 'Mutation', runProjectImport: { __typename?: 'ProjectImport', id: string | null, name: string | null, status: ProjectImportStatus | null } | null };

export type RunProjectImportWithoutInvitesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RunProjectImportWithoutInvitesMutation = { __typename?: 'Mutation', runProjectImport: { __typename?: 'ProjectImport', id: string | null, name: string | null, status: ProjectImportStatus | null } | null };

export type SentimentAnalysisQueryVariables = Exact<{
  content: Scalars['String']['input'];
  contentExtent?: InputMaybe<ContentExtent>;
  sentiments?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type SentimentAnalysisQuery = { __typename?: 'Query', sentimentAnalysis: { __typename?: 'SentimentAnalysisResponse', sentimentAnalysisId: string } | null };

export type TransferProjectOwnershipToTeamMemberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  teamMemberId: Scalars['ID']['input'];
}>;


export type TransferProjectOwnershipToTeamMemberMutation = { __typename?: 'Mutation', transferProjectOwnershipToTeamMember: { __typename?: 'OkResponse', ok: boolean | null } | null };

export type UpdateCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCodeMutation = { __typename?: 'Mutation', updateCode: { __typename?: 'UpdateCodeResponse', code: { __typename?: 'Code', updatedAt: any | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null }, children: Array<{ __typename?: 'Code', updatedAt: any | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null> | null } | null };

export type UpdateFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFolderMutation = { __typename?: 'Mutation', updateFolder: { __typename?: 'Folder', id: string | null, name: string | null, comment: string | null, color: string | null, updatedAt: any | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null } | null };

export type UpdateMemoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  bibReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMemoMutation = { __typename?: 'Mutation', updateMemo: { __typename?: 'Memo', id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null };

export type UpdateMemoContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  steps: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  clientID: Scalars['String']['input'];
}>;


export type UpdateMemoContentMutation = { __typename?: 'Mutation', updateMemoContent: { __typename?: 'StepsResponse', steps: Array<string | null> | null, clientIDs: Array<string | null> | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null } | null };

export type UpdateProjectSupportAccessMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  allowSupportAccess: Scalars['Boolean']['input'];
}>;


export type UpdateProjectSupportAccessMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string | null, allowSupportAccess: boolean | null, activeTeamMemberCount: number | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, invitations: Array<{ __typename?: 'Invitation', id: string | null, email: string | null, firstname: string | null, lastname: string | null, user: { __typename?: 'User', id: string | null, image: string | null, fullname: string | null } | null } | null> | null } | null };

export type UpdateQuotationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
  containsImage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateQuotationMutation = { __typename?: 'Mutation', updateQuotation: { __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null };

export type UpdateReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', id: string | null, name: string | null, comment: string | null, type: string | null, settings: string | null } | null };

export type UpdateSourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  bibReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSourceMutation = { __typename?: 'Mutation', updateSource: { __typename?: 'Source', id: string | null, name: string | null, comment: string | null, bibReference: string | null } | null };

export type UpdateSourceContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  steps: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  clientID: Scalars['String']['input'];
}>;


export type UpdateSourceContentMutation = { __typename?: 'Mutation', updateSourceContent: { __typename?: 'StepsResponse', steps: Array<string | null> | null, clientIDs: Array<string | null> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mayReceiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string | null, firstname: string | null, lastname: string | null, fullname: string | null, email: string | null, locale: string | null, image: string | null, imageIsGravatar: boolean | null, createdAt: any | null, confirmedAt: any | null, mayReceiveEmails: boolean | null, isSupportAgent: boolean | null, helpscoutHashes: { __typename?: 'HelpscoutHash', default: string, es: string } | null } | null };

export type UpdateUserImageMutationVariables = Exact<{
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UpdateUserImageMutation = { __typename?: 'Mutation', updateUserImage: { __typename?: 'User', id: string | null, image: string | null } | null };

export type ActiveUsersBySourceQueryVariables = Exact<{
  sourceId: Scalars['ID']['input'];
}>;


export type ActiveUsersBySourceQuery = { __typename?: 'Query', activeUsersBySource: Array<{ __typename?: 'User', id: string | null, firstname: string | null, lastname: string | null, fullname: string | null, email: string | null, locale: string | null, image: string | null, confirmedAt: any | null, mayReceiveEmails: boolean | null } | null> | null };

export type AiCodeSuggestionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type AiCodeSuggestionsQuery = { __typename?: 'Query', aiCodeSuggestions: { __typename?: 'AiCodeSuggestionsResponse', codes: Array<{ __typename?: 'AiCodeSuggestion', id: string, color: string | null, isNewCode: boolean, name: string, comment: string | null, parent: { __typename?: 'AiCodeSuggestion', id: string } | null } | null>, parentCodes: Array<{ __typename?: 'AiCodeSuggestion', id: string, color: string | null, isNewCode: boolean, name: string, comment: string | null, parent: { __typename?: 'AiCodeSuggestion', id: string } | null } | null> } | null };

export type AiCodingQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  estimate?: InputMaybe<AiEstimate>;
  aiCodingId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AiCodingQuery = { __typename?: 'Query', aiCoding: { __typename?: 'RunAiCodingResponse', aiCodingId: string, status: string | null } | null };

export type AiCodingLocalQueryVariables = Exact<{ [key: string]: never; }>;


export type AiCodingLocalQuery = { __typename: 'Query', aiCodingCreatedQuotations: Array<{ __typename: 'AiCodingQuotation', name: string | null } | null> | null, aiCodingCreatedCodes: Array<{ __typename: 'AiCodingCode', id: string, name: string | null, color: string | null, comment: string | null, occurrence: number | null } | null> | null };

export type AiEstimateAiCodingQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AiEstimateAiCodingQuery = { __typename?: 'Query', aiEstimateAiCoding: { __typename?: 'AiEstimateResponse', timeToCompleteInMilliseconds: string | null, tokenCount: string | null, availableTokenCount: string | null } | null };

export type AiEstimateIntentionalCodingQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  questions?: InputMaybe<Array<AiIntentionalCodingQuestionInput> | AiIntentionalCodingQuestionInput>;
}>;


export type AiEstimateIntentionalCodingQuery = { __typename?: 'Query', aiEstimateIntentionalCoding: { __typename?: 'AiEstimateResponse', tokenCount: string | null, availableTokenCount: string | null, timeToCompleteInMilliseconds: string | null } | null };

export type AiGenerateIntentionalCodingQuestionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  intentionPrompt: Scalars['String']['input'];
}>;


export type AiGenerateIntentionalCodingQuestionsQuery = { __typename?: 'Query', aiGenerateIntentionalCodingQuestions: { __typename?: 'AiGenerateIntentionalCodingQuestionsResponse', aiGenerateIntentionalCodingQuestionsId: string | null, status: string | null } | null };

export type AiIntentionalCodingQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  questions?: InputMaybe<Array<AiIntentionalCodingQuestionInput> | AiIntentionalCodingQuestionInput>;
  estimate?: InputMaybe<AiEstimate>;
}>;


export type AiIntentionalCodingQuery = { __typename?: 'Query', aiIntentionalCoding: { __typename?: 'AiIntentionalCodingResponse', jobId: string | null, status: string | null } | null };

export type GlobalSearchQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  query: GlobalSearchQueryInput;
}>;


export type GlobalSearchQuery = { __typename?: 'Query', globalSearch: Array<{ __typename?: 'GlobalSearchQueryHit', searchTerm: string, fragmentTexts: Array<{ __typename?: 'FragmentText', from: number, sourceId: string, text: string, to: number, sentences: Array<{ __typename?: 'SentenceMatch', from: number, to: number, exact: Array<{ __typename?: 'ExactMatch', from: number, to: number }> }> }> }> };

export type MemoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MemoQuery = { __typename?: 'Query', memo: { __typename?: 'Memo', content: string | null, version: number | null, id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null };

export type MemoChangesQueryVariables = Exact<{
  memoId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type MemoChangesQuery = { __typename?: 'Query', memoChanges: { __typename?: 'StepsResponse', steps: Array<string | null> | null, clientIDs: Array<string | null> | null } | null };

export type MemoEmbeddedFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}>;


export type MemoEmbeddedFileQuery = { __typename?: 'Query', memo: { __typename?: 'Memo', id: string | null, embeddedFile: { __typename?: 'File', id: string | null, type: string | null, location: string | null, key: string | null } | null } | null };

export type MemoMetaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MemoMetaQuery = { __typename?: 'Query', memo: { __typename?: 'Memo', id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null };

export type ProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, allowSupportAccess: boolean | null, recentCodeIds: Array<string | null> | null, isImported: boolean | null, activeTeamMemberCount: number | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null, sources: Array<{ __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, codes: Array<{ __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null }>, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null> | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, source: { __typename?: 'Source', id: string | null, name: string | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null }, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null }>, codes: Array<{ __typename?: 'Code', comment: string | null, createdAt: any | null, updatedAt: any | null, occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, isCategory: boolean | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null> | null, memos: Array<{ __typename?: 'Memo', id: string | null, name: string | null, bibReference: string | null, comment: string | null, type: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codeFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, sourceFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, memoFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, reportFolders: Array<{ __typename?: 'Folder', id: string | null, uuid: string | null, name: string | null, color: string | null, comment: string | null, type: FolderEntityType | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, entities: Array<{ __typename: 'Code', id: string | null } | { __typename: 'Memo', id: string | null } | { __typename: 'Report', id: string | null } | { __typename: 'Source', id: string | null } | null> | null, parent: { __typename?: 'Folder', id: string | null } | null, childrenFolders: Array<{ __typename?: 'Folder', id: string | null } | null> | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, occurrence: number | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | { __typename?: 'Memo' } | { __typename?: 'Source' } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code' } | { __typename?: 'Memo' } | { __typename?: 'Source', id: string | null, name: string | null, comment: string | null } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code' } | { __typename?: 'Memo', id: string | null, name: string | null, comment: string | null } | { __typename?: 'Source' } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, reports: Array<{ __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null, createdAt: any | null, updatedAt: any | null, folder: { __typename?: 'Folder', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, importedTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, leftTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, email: string | null, fullname: string | null } | null } | null> | null, importedColors: Array<{ __typename?: 'Color', id: string | null, name: string | null, rgb: string | null } | null> | null, activeAiCoding: Array<{ __typename?: 'AiCodingJob', aiCodingId: string } | null> | null, recentlyCompletedAiCoding: Array<{ __typename?: 'AiCodingJob', aiCodingId: string } | null> | null, invitations: Array<{ __typename?: 'Invitation', id: string | null, email: string | null, firstname: string | null, lastname: string | null, user: { __typename?: 'User', id: string | null, image: string | null, fullname: string | null } | null } | null> | null } | null };

export type ProjectExportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectExportQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, uuid: string | null, owner: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, codeGroups: Array<{ __typename?: 'Group', id: string | null, uuid: string | null, name: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, updatedBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null, uuid: string | null, name: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, updatedBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null, uuid: string | null, name: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, updatedBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null } | null> | null, codes: Array<{ __typename?: 'Code', id: string | null, uuid: string | null, name: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, comment: string | null, createdBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, updatedBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null, sources: Array<{ __typename?: 'Source', uuid: string | null, name: string | null, comment: string | null, content: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, updatedBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, quotations: Array<{ __typename?: 'Quotation', uuid: string | null, comment: string | null, from: number | null, to: number | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, updatedBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, codes: Array<{ __typename?: 'CodeAttachment', attachedAt: any | null, attachedBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, code: { __typename?: 'Code', id: string | null, name: string | null, color: string | null, occurrence: number | null } | null } | null> | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null, memos: Array<{ __typename?: 'Memo', uuid: string | null, name: string | null, comment: string | null, content: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, updatedBy: { __typename?: 'User', uuid: string | null, firstname: string | null, lastname: string | null } | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null } | null };

export type ProjectExportXlsxQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectExportXlsxQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string | null, name: string | null, sources: Array<{ __typename?: 'Source', id: string | null, name: string | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, code: { __typename?: 'Code', id: string | null, name: string | null, fullname: string | null } | null } | null> | null } | null> | null } | null> | null, codes: Array<{ __typename?: 'Code', id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, occurrence: number | null, groups: Array<{ __typename?: 'Group', id: string | null, name: string | null } | null> | null } | null> | null } | null };

export type ProjectGroupsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectGroupsQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string | null, codeGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code', id: string | null, name: string | null, comment: string | null, color: string | null, occurrence: number | null } | { __typename?: 'Memo' } | { __typename?: 'Source' } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code' } | { __typename?: 'Memo' } | { __typename?: 'Source', id: string | null, name: string | null, comment: string | null } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, contents: Array<{ __typename?: 'Code' } | { __typename?: 'Memo', id: string | null, name: string | null, comment: string | null } | { __typename?: 'Source' } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null };

export type ProjectImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectImportQuery = { __typename?: 'Query', projectImport: { __typename?: 'ProjectImport', id: string | null, status: ProjectImportStatus | null, name: string | null, project: { __typename?: 'Project', id: string | null } | null, knownUsers: Array<{ __typename?: 'ProjectImportUser', aprxId: string, fullname: string, firstname: string | null, lastname: string | null } | null> | null, unknownUsers: Array<{ __typename?: 'ProjectImportUser', aprxId: string, fullname: string } | null> | null } | null };

export type ProjectTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectTemplateQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, codes: Array<{ __typename?: 'Code', id: string | null, name: string | null, color: string | null, comment: string | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null, sources: Array<{ __typename?: 'Source', name: string | null, comment: string | null, content: string | null, quotations: Array<{ __typename?: 'Quotation', name: string | null, comment: string | null, from: number | null, to: number | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, code: { __typename?: 'Code', id: string | null } | null } | null> | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null, memos: Array<{ __typename?: 'Memo', name: string | null, comment: string | null, content: string | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null, name: string | null, comment: string | null, type: string | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null, name: string | null, comment: string | null, type: string | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null, name: string | null, comment: string | null, type: string | null } | null> | null } | null };

export type ProjectWithProjectImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectWithProjectImportQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string | null, name: string | null, isImported: boolean | null, projectImport: { __typename?: 'ProjectImport', name: string | null, fileDownloadUrl: string | null } | null } | null };

export type ReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportQuery = { __typename?: 'Query', report: { __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null, createdAt: any | null, updatedAt: any | null, folder: { __typename?: 'Folder', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null };

export type ScholarPaperSearchAiSummaryCacheQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  filterList?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScholarPaperSearchAiSummaryCacheQuery = { __typename?: 'Query', scholarPaperSearchAiSummary: { __typename?: 'ScholarPaperSearchAiSummary', skip: number | null, limit: number | null, emptyAiSummaryReason: ScholarAiSummaryEmptyReason | null, aiSummary: { __typename?: 'ScholarAiSummary', conclusion: string, references: Array<{ __typename?: 'ScholarAiSummaryReference', reference: string, paperId: string } | null>, keyInsights: Array<{ __typename?: 'ScholarAiSummaryInsight', title: string, points: Array<string | null> } | null> } | null, referencedPapers: Array<{ __typename?: 'ScholarResult', paperId: string, sourceId: string | null, corpusId: number, title: string, abstract: string | null, tldr: string | null, publicationDate: string | null, year: number | null, referenceCount: number, citationCount: number, influentialCitationCount: number, fieldsOfStudyNormalized: Array<string | null>, publicationTypes: Array<string | null>, isOpenAccess: boolean | null, venue: string | null, openAccessPdf: { __typename?: 'ScholarPdf', url: string | null } | null, authors: Array<{ __typename?: 'ScholarAuthor', authorId: string | null, name: string | null } | null> | null, externalIds: { __typename?: 'ScholarExternalIds', DOI: string | null, PubMed: string | null } | null } | null> | null } | null };

export type SourceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  pageLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SourceQuery = { __typename?: 'Query', source: { __typename?: 'Source', fileLocation: string | null, pdfPages: Array<string | null> | null, content: string | null, version: number | null, storedPdfPagesCount: number | null, semanticScholarPaperId: string | null, id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, quotations: Array<{ __typename?: 'Quotation', codeCount: number | null, deletedAt: any | null, id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null };

export type SourceChangesQueryVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type SourceChangesQuery = { __typename?: 'Query', sourceChanges: { __typename?: 'SourceChangesResponse', steps: Array<string | null> | null, clientIDs: Array<string | null> | null, quotations: Array<{ __typename?: 'Quotation', codeCount: number | null, deletedAt: any | null, id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null };

export type SourceEmbeddedFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}>;


export type SourceEmbeddedFileQuery = { __typename?: 'Query', source: { __typename?: 'Source', id: string | null, embeddedFile: { __typename?: 'File', id: string | null, type: string | null, location: string | null, key: string | null } | null } | null };

export type SourcePdfPagesQueryVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SourcePdfPagesQuery = { __typename?: 'Query', source: { __typename?: 'Source', id: string | null, pdfPages: Array<string | null> | null } | null };

export type SourcePdfPlutQueryVariables = Exact<{
  sourceId: Scalars['ID']['input'];
}>;


export type SourcePdfPlutQuery = { __typename?: 'Query', source: { __typename?: 'Source', id: string | null, plutFile: { __typename?: 'File', id: string | null, location: string | null } | null } | null };

export type SourceQuotationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SourceQuotationsQuery = { __typename?: 'Query', source: { __typename?: 'Source', id: string | null, quotations: Array<{ __typename?: 'Quotation', codeCount: number | null, deletedAt: any | null, id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null };

export type TestTemplateQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  teamMemberStatus?: InputMaybe<Scalars['String']['input']>;
}>;


export type TestTemplateQuery = { __typename?: 'Query', testTemplate: { __typename?: 'User', id: string | null, firstname: string | null, lastname: string | null, email: string | null, locale: string | null, createdAt: any | null, updatedAt: any | null, projectsJoined: Array<{ __typename?: 'Project', id: string | null } | null> | null, projects: Array<{ __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, codes: Array<{ __typename?: 'Code', id: string | null, name: string | null, color: string | null, comment: string | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null, sources: Array<{ __typename?: 'Source', id: string | null, name: string | null, comment: string | null, content: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileLocation: string | null, fileType: string | null, pdfPages: Array<string | null> | null, createdBy: { __typename?: 'User', id: string | null } | null, updatedBy: { __typename?: 'User', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, name: string | null, comment: string | null, from: number | null, to: number | null, createdAt: any | null, updatedAt: any | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null } | null, code: { __typename?: 'Code', id: string | null } | null } | null> | null, createdBy: { __typename?: 'User', id: string | null } | null, updatedBy: { __typename?: 'User', id: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null, memos: Array<{ __typename?: 'Memo', name: string | null, comment: string | null, content: string | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null, name: string | null, comment: string | null, type: string | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null, name: string | null, comment: string | null, type: string | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null, name: string | null, comment: string | null, type: string | null } | null> | null, reports: Array<{ __typename?: 'Report', id: string | null, name: string | null, type: string | null, comment: string | null, settings: string | null } | null> | null, invitations: Array<{ __typename?: 'Invitation', firstname: string | null, lastname: string | null, email: string | null, message: string | null, status: InvitationStatus | null, createdAt: any | null, updatedAt: any | null, rejectedAt: any | null, deletedAt: any | null, user: { __typename?: 'User', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null } | null, updatedBy: { __typename?: 'User', id: string | null } | null, deletedBy: { __typename?: 'User', id: string | null } | null } | null> | null, teamMembers: Array<{ __typename?: 'TeamMember', status: TeamMemberStatus | null, createdAt: any | null, updatedAt: any | null, deletedAt: any | null, leftAt: any | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null } | null, createdBy: { __typename?: 'User', id: string | null } | null, deactivatedBy: { __typename?: 'User', id: string | null } | null, updatedBy: { __typename?: 'User', id: string | null } | null, deletedBy: { __typename?: 'User', id: string | null } | null } | null> | null } | null> | null } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string | null, firstname: string | null, lastname: string | null, fullname: string | null, email: string | null, locale: string | null, image: string | null, imageIsGravatar: boolean | null, createdAt: any | null, confirmedAt: any | null, mayReceiveEmails: boolean | null, isSupportAgent: boolean | null, helpscoutHashes: { __typename?: 'HelpscoutHash', default: string, es: string } | null } | null };

export type UserFullIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFullIdsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string | null, projects: Array<{ __typename?: 'Project', id: string | null, sources: Array<{ __typename?: 'Source', id: string | null, pdfPages: Array<string | null> | null, fileLocation: string | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, codes: Array<{ __typename?: 'CodeAttachment', code: { __typename?: 'Code', id: string | null } | null } | null> | null } | null> | null, file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null, embeddedFiles: Array<{ __typename?: 'EmbeddedFile', file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codes: Array<{ __typename?: 'Code', id: string | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, memos: Array<{ __typename?: 'Memo', id: string | null, embeddedFiles: Array<{ __typename?: 'EmbeddedFile', file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, reports: Array<{ __typename?: 'Report', id: string | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, invitations: Array<{ __typename?: 'Invitation', id: string | null } | null> | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null } | null> | null, leftTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null } | null> | null, importedColors: Array<{ __typename?: 'Color', id: string | null } | null> | null } | null> | null, projectsJoined: Array<{ __typename?: 'Project', id: string | null, sources: Array<{ __typename?: 'Source', id: string | null, pdfPages: Array<string | null> | null, fileLocation: string | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, codes: Array<{ __typename?: 'CodeAttachment', code: { __typename?: 'Code', id: string | null } | null } | null> | null } | null> | null, file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null, embeddedFiles: Array<{ __typename?: 'EmbeddedFile', file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codes: Array<{ __typename?: 'Code', id: string | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, memos: Array<{ __typename?: 'Memo', id: string | null, embeddedFiles: Array<{ __typename?: 'EmbeddedFile', file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, reports: Array<{ __typename?: 'Report', id: string | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, invitations: Array<{ __typename?: 'Invitation', id: string | null } | null> | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null } | null> | null, leftTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null } | null> | null, importedColors: Array<{ __typename?: 'Color', id: string | null } | null> | null } | null> | null, projectsInvited: Array<{ __typename?: 'Project', id: string | null, sources: Array<{ __typename?: 'Source', id: string | null, pdfPages: Array<string | null> | null, fileLocation: string | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, codes: Array<{ __typename?: 'CodeAttachment', code: { __typename?: 'Code', id: string | null } | null } | null> | null } | null> | null, file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null, embeddedFiles: Array<{ __typename?: 'EmbeddedFile', file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codes: Array<{ __typename?: 'Code', id: string | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, memos: Array<{ __typename?: 'Memo', id: string | null, embeddedFiles: Array<{ __typename?: 'EmbeddedFile', file: { __typename?: 'File', id: string | null, key: string | null, location: string | null } | null } | null> | null, groups: Array<{ __typename?: 'Group', id: string | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, codeGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, sourceGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, memoGroups: Array<{ __typename?: 'Group', id: string | null } | null> | null, reports: Array<{ __typename?: 'Report', id: string | null, folder: { __typename?: 'Folder', id: string | null } | null } | null> | null, invitations: Array<{ __typename?: 'Invitation', id: string | null } | null> | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null } | null> | null, leftTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null } | null> | null, importedColors: Array<{ __typename?: 'Color', id: string | null } | null> | null } | null> | null } | null };

export type UserProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProjectsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string | null, projects: Array<{ __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null> | null, projectsJoined: Array<{ __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null> | null, projectsInvited: Array<{ __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null> | null } | null };

export type WordQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type WordQuery = { __typename?: 'Query', word: { __typename?: 'Word', name: string | null, synonyms: Array<{ __typename?: 'Word', name: string | null, category: WordCategory | null } | null> | null } | null };

export type ScholarCitationQueryVariables = Exact<{
  semanticScholarId: Scalars['String']['input'];
}>;


export type ScholarCitationQuery = { __typename?: 'Query', scholarCitation: { __typename?: 'ScholarCitationResponse', formats: Array<{ __typename?: 'Citation', name: string | null, html: string | null } | null> | null } | null };

export type ScholarPaperConclusionQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  researchQuestion: Scalars['String']['input'];
  paperId: Scalars['String']['input'];
  abstract: Scalars['String']['input'];
}>;


export type ScholarPaperConclusionQuery = { __typename?: 'Query', scholarPaperConclusion: { __typename?: 'ScholarPaperConclusionResponse', paperConclusion: string | null } | null };

export type ScholarPaperSearchQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filterList?: InputMaybe<Scalars['String']['input']>;
  createAiSummary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ScholarPaperSearchQuery = { __typename?: 'Query', scholarPaperSearch: { __typename?: 'ScholarPaperSearchResponse', hasMore: boolean | null, total: number | null, results: Array<{ __typename?: 'ScholarResult', paperId: string, sourceId: string | null, corpusId: number, title: string, abstract: string | null, tldr: string | null, publicationDate: string | null, year: number | null, referenceCount: number, citationCount: number, influentialCitationCount: number, fieldsOfStudyNormalized: Array<string | null>, publicationTypes: Array<string | null>, isOpenAccess: boolean | null, venue: string | null, openAccessPdf: { __typename?: 'ScholarPdf', url: string | null } | null, authors: Array<{ __typename?: 'ScholarAuthor', authorId: string | null, name: string | null } | null> | null, externalIds: { __typename?: 'ScholarExternalIds', DOI: string | null, PubMed: string | null } | null } | null> | null } | null };

export type AiCodingProgressSubscriptionVariables = Exact<{
  aiCodingId: Scalars['ID']['input'];
}>;


export type AiCodingProgressSubscription = { __typename?: 'Subscription', aiCodingProgress: { __typename?: 'AiCodingProgressResponse', aiCodingId: string, projectId: string | null, status: string | null, progressPercent: number | null, codes: Array<{ __typename?: 'AiCodingCode', id: string, color: string | null, isNewCode: boolean | null, fullname: string | null, name: string | null, occurrence: number | null, comment: string | null, parent: { __typename?: 'AiCodingCode', id: string, name: string | null } | null } | null> | null, parentCodes: Array<{ __typename?: 'AiCodingCode', id: string, color: string | null, isNewCode: boolean | null, fullname: string | null, name: string | null, occurrence: number | null, comment: string | null, parent: { __typename?: 'AiCodingCode', id: string, name: string | null } | null } | null> | null, quotations: Array<{ __typename?: 'AiCodingQuotation', sourceName: string | null, sourceId: string | null, from: number | null, to: number | null, id: string, codes: Array<string | null> | null, isNew: boolean | null, name: string | null } | null> | null } | null };

export type AiGenerateIntentionalCodingQuestionsProgressSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiGenerateIntentionalCodingQuestionsProgressSubscription = { __typename?: 'Subscription', aiGenerateIntentionalCodingQuestionsProgress: { __typename?: 'AiGenerateIntentionalCodingQuestionsProgressResponse', id: string | null, progressPercent: number | null, status: string | null, preparedQuestions: string | null, questions: Array<{ __typename?: 'AiIntentionalCodingQuestion', title: string | null, content: string | null, code: { __typename?: 'AiCodingCode', id: string, color: string | null, isNewCode: boolean | null, fullname: string | null, name: string | null, occurrence: number | null, comment: string | null, parent: { __typename?: 'AiCodingCode', id: string, name: string | null } | null } | null } | null> | null } | null };

export type AiIntentionalCodingProgressSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiIntentionalCodingProgressSubscription = { __typename?: 'Subscription', aiIntentionalCodingProgress: { __typename?: 'AiIntentionalCodingProgressResponse', jobId: string | null, projectId: string | null, status: string | null, progressPercent: number | null, codes: Array<{ __typename?: 'AiCodingCode', id: string, color: string | null, isNewCode: boolean | null, fullname: string | null, name: string | null, occurrence: number | null, comment: string | null, parent: { __typename?: 'AiCodingCode', id: string, name: string | null } | null } | null> | null, parentCodes: Array<{ __typename?: 'AiCodingCode', id: string, color: string | null, isNewCode: boolean | null, fullname: string | null, name: string | null, occurrence: number | null, comment: string | null, parent: { __typename?: 'AiCodingCode', id: string, name: string | null } | null } | null> | null, quotations: Array<{ __typename?: 'AiCodingQuotation', sourceName: string | null, sourceId: string | null, from: number | null, to: number | null, id: string, codes: Array<string | null> | null, isNew: boolean | null, name: string | null } | null> | null } | null };

export type ConceptAnalysisProgressSubscriptionVariables = Exact<{
  conceptAnalysisId: Scalars['ID']['input'];
}>;


export type ConceptAnalysisProgressSubscription = { __typename?: 'Subscription', conceptAnalysisProgress: { __typename?: 'ConceptAnalysisProgressResponse', conceptAnalysisId: string, projectId: string | null, status: string | null, progressPercent: number | null, concepts: Array<{ __typename?: 'ConceptAnalysis', concept: string | null, count: number | null, matches: Array<{ __typename?: 'ConceptMatch', match: string | null, count: number | null, locations: Array<{ __typename?: 'ConceptLocation', document: string | null, text: string | null, range: { __typename?: 'LocationRange', start: number | null, length: number | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type CreateSourcesCsvProgressSubscriptionVariables = Exact<{
  projectId: Scalars['ID']['input'];
  batchId: Scalars['String']['input'];
}>;


export type CreateSourcesCsvProgressSubscription = { __typename?: 'Subscription', createSourcesCsvProgress: { __typename?: 'CreateSourcesCsvProgressResponse', batchId: string | null, projectId: string | null, status: string | null, current: number | null, total: number | null } | null };

export type ProjectCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ProjectCreatedSubscription = { __typename?: 'Subscription', projectCreated: { __typename?: 'Project', id: string | null, name: string | null, description: string | null, color: string | null, createdAt: any | null, updatedAt: any | null, owner: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, activeTeamMembers: Array<{ __typename?: 'TeamMember', id: string | null, lastActiveAt: any | null, user: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null } | null };

export type ProjectExportProgressSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectExportProgressSubscription = { __typename?: 'Subscription', projectExportProgress: { __typename?: 'ProjectExportProgressResponse', id: string, projectId: string, status: string, exportLocation: string | null, fileName: string | null, current: number | null, total: number | null } | null };

export type ProjectImportProgressSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectImportProgressSubscription = { __typename?: 'Subscription', projectImportProgress: { __typename?: 'ProjectImportProgressResponse', id: string | null, projectId: string | null, status: string | null, current: number | null, total: number | null } | null };

export type ScholarPaperSearchAiSummarySubscriptionVariables = Exact<{
  projectId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  filterList?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScholarPaperSearchAiSummarySubscription = { __typename?: 'Subscription', scholarPaperSearchAiSummary: { __typename?: 'ScholarPaperSearchAiSummary', skip: number | null, limit: number | null, emptyAiSummaryReason: ScholarAiSummaryEmptyReason | null, aiSummary: { __typename?: 'ScholarAiSummary', conclusion: string, references: Array<{ __typename?: 'ScholarAiSummaryReference', reference: string, paperId: string } | null>, keyInsights: Array<{ __typename?: 'ScholarAiSummaryInsight', title: string, points: Array<string | null> } | null> } | null, referencedPapers: Array<{ __typename?: 'ScholarResult', paperId: string, sourceId: string | null, corpusId: number, title: string, abstract: string | null, tldr: string | null, publicationDate: string | null, year: number | null, referenceCount: number, citationCount: number, influentialCitationCount: number, fieldsOfStudyNormalized: Array<string | null>, publicationTypes: Array<string | null>, isOpenAccess: boolean | null, venue: string | null, openAccessPdf: { __typename?: 'ScholarPdf', url: string | null } | null, authors: Array<{ __typename?: 'ScholarAuthor', authorId: string | null, name: string | null } | null> | null, externalIds: { __typename?: 'ScholarExternalIds', DOI: string | null, PubMed: string | null } | null } | null> | null } | null };

export type SentimentAnalysisProgressSubscriptionVariables = Exact<{
  sentimentAnalysisId: Scalars['ID']['input'];
}>;


export type SentimentAnalysisProgressSubscription = { __typename?: 'Subscription', sentimentAnalysisProgress: { __typename?: 'SentimentAnalysisProgressResponse', sentimentAnalysisId: string, status: string | null, progressPercent: number | null, locations: Array<{ __typename?: 'SentimentLocation', range: { __typename?: 'LocationRange', start: number | null, length: number | null } | null, analysis: { __typename?: 'SentimentAnalysis', language: string | null, sentiment: number | null } | null } | null> | null } | null };

export type SourcesCreatedSubscriptionVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SourcesCreatedSubscription = { __typename?: 'Subscription', sourcesCreated: Array<{ __typename?: 'Source', id: string | null, name: string | null, comment: string | null, type: string | null, lastOpenedAt: any | null, createdAt: any | null, updatedAt: any | null, fileType: string | null, isEmpty: boolean | null, bibReference: string | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, quotations: Array<{ __typename?: 'Quotation', id: string | null, comment: string | null, name: string | null, from: number | null, to: number | null, containsImage: boolean | null, createdAt: any | null, updatedAt: any | null, codeCount: number | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, codes: Array<{ __typename?: 'CodeAttachment', quotationId: string | null, attachedAt: any | null, attachedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, code: { __typename?: 'Code', occurrence: number | null, id: string | null, name: string | null, fullname: string | null, color: string | null, comment: string | null, isCategory: boolean | null, groups: Array<{ __typename?: 'Group', id: string | null, type: string | null, name: string | null, comment: string | null, createdAt: any | null, updatedAt: any | null, createdBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null, updatedBy: { __typename?: 'User', id: string | null, image: string | null, firstname: string | null, lastname: string | null, fullname: string | null, isPlaceholder: boolean | null } | null } | null> | null, folder: { __typename?: 'Folder', id: string | null } | null, parent: { __typename?: 'Code', id: string | null, name: string | null } | null } | null } | null> | null } | null> | null } | null> | null };

export const AiCodeSuggestionDefaultFragmentDoc = gql`
    fragment AiCodeSuggestionDefault on AiCodeSuggestion {
  id
  color
  isNewCode
  name
  comment
  parent {
    id
  }
}
    `;
export const AiCodingCodeDefaultFragmentDoc = gql`
    fragment AiCodingCodeDefault on AiCodingCode {
  id
  color
  isNewCode
  fullname
  name
  occurrence
  comment
  parent {
    id
    name
  }
}
    `;
export const AiCodingQuotationDefaultFragmentDoc = gql`
    fragment AiCodingQuotationDefault on AiCodingQuotation {
  sourceName
  sourceId
  from
  to
  id
  codes
  isNew
  name
}
    `;
export const FileDefaultFragmentDoc = gql`
    fragment FileDefault on File {
  id
  type
  location
  key
}
    `;
export const EmbeddedFileDefaultFragmentDoc = gql`
    fragment EmbeddedFileDefault on EmbeddedFile {
  id
  createdAt
  updatedAt
  deletedAt
  file {
    ...FileDefault
  }
}
    ${FileDefaultFragmentDoc}`;
export const GroupContentsFragmentDoc = gql`
    fragment GroupContents on Group {
  id
  contents {
    __typename
    ... on Code {
      id
      name @client
      comment @client
      color @client
      parent @client {
        id
      }
    }
    ... on Source {
      id
      name @client
      comment @client
    }
    ... on Memo {
      id
      name @client
      comment @client
    }
  }
}
    `;
export const CodeDefaultFragmentDoc = gql`
    fragment CodeDefault on Code {
  id
  name
  fullname
  color
  comment
  folder {
    id
  }
  isCategory
  parent {
    id
    name
  }
}
    `;
export const UserActivityFragmentDoc = gql`
    fragment UserActivity on User {
  id
  image
  firstname
  lastname
  fullname @client
  isPlaceholder @client
}
    `;
export const GroupDefaultFragmentDoc = gql`
    fragment GroupDefault on Group {
  id
  type
  name
  comment
  createdAt
  createdBy {
    ...UserActivity
  }
  updatedAt
  updatedBy {
    ...UserActivity
  }
}
    ${UserActivityFragmentDoc}`;
export const CodeGroupsFragmentDoc = gql`
    fragment CodeGroups on Code {
  groups {
    ...GroupDefault
  }
}
    ${GroupDefaultFragmentDoc}`;
export const ProjectCodeFragmentDoc = gql`
    fragment ProjectCode on Code {
  ...CodeDefault
  comment
  createdAt
  updatedAt
  createdBy {
    ...UserActivity
  }
  updatedBy {
    ...UserActivity
  }
  ...CodeGroups
}
    ${CodeDefaultFragmentDoc}
${UserActivityFragmentDoc}
${CodeGroupsFragmentDoc}`;
export const UserInTeamFragmentDoc = gql`
    fragment UserInTeam on User {
  id
  image
  firstname
  lastname
  email
  fullname @client
}
    `;
export const QuotationDefaultFragmentDoc = gql`
    fragment QuotationDefault on Quotation {
  id
  comment
  name
  from
  to
  containsImage
  createdAt
  createdBy {
    ...UserActivity
  }
  updatedAt
  updatedBy {
    ...UserActivity
  }
  codeCount
  codes {
    quotationId
    attachedAt
    attachedBy {
      ...UserActivity
    }
    code {
      ...CodeDefault
      occurrence @client
      groups {
        ...GroupDefault
      }
    }
  }
}
    ${UserActivityFragmentDoc}
${CodeDefaultFragmentDoc}
${GroupDefaultFragmentDoc}`;
export const SourceDefaultFragmentDoc = gql`
    fragment SourceDefault on Source {
  id
  name
  comment
  type
  lastOpenedAt
  createdAt
  createdBy {
    ...UserActivity
  }
  updatedAt
  updatedBy {
    ...UserActivity
  }
  groups {
    ...GroupDefault
  }
  folder {
    id
  }
  fileType
  isEmpty
  bibReference
  quotations {
    ...QuotationDefault
  }
}
    ${UserActivityFragmentDoc}
${GroupDefaultFragmentDoc}
${QuotationDefaultFragmentDoc}`;
export const MemoDefaultFragmentDoc = gql`
    fragment MemoDefault on Memo {
  id
  name
  bibReference
  comment
  type
  createdAt
  createdBy {
    ...UserActivity
  }
  updatedAt
  updatedBy {
    ...UserActivity
  }
  groups {
    ...GroupDefault
  }
  folder {
    id
  }
}
    ${UserActivityFragmentDoc}
${GroupDefaultFragmentDoc}`;
export const FolderDefaultFragmentDoc = gql`
    fragment FolderDefault on Folder {
  id
  uuid
  name
  color
  comment
  type
  createdAt
  createdBy {
    ...UserActivity
  }
  updatedAt
  updatedBy {
    ...UserActivity
  }
  entities {
    __typename
    ... on Code {
      id
    }
    ... on Memo {
      id
    }
    ... on Source {
      id
    }
    ... on Report {
      id
    }
  }
  parent {
    id
  }
  childrenFolders {
    id
  }
}
    ${UserActivityFragmentDoc}`;
export const ReportDefaultFragmentDoc = gql`
    fragment ReportDefault on Report {
  id
  name
  type
  comment
  settings
  folder {
    id
  }
  createdAt
  updatedAt
  createdBy {
    ...UserActivity
  }
  updatedBy {
    ...UserActivity
  }
}
    ${UserActivityFragmentDoc}`;
export const InvitationFragmentDoc = gql`
    fragment Invitation on Invitation {
  id
  email
  firstname
  lastname
  user {
    id
    image
    fullname
  }
}
    `;
export const ProjectInvitationsFragmentDoc = gql`
    fragment ProjectInvitations on Project {
  invitations {
    ...Invitation
  }
}
    ${InvitationFragmentDoc}`;
export const ProjectDefaultFragmentDoc = gql`
    fragment ProjectDefault on Project {
  id
  name
  description
  color
  owner {
    ...UserInTeam
  }
  allowSupportAccess
  sources {
    ...SourceDefault
    codes @client {
      ...CodeDefault
      occurrence @client
      groups {
        id
        type
        name
      }
    }
  }
  quotations @client {
    ...QuotationDefault
    source @client {
      id
      name
      groups {
        ...GroupDefault
      }
    }
  }
  codes {
    ...CodeDefault
    comment
    createdAt
    updatedAt
    createdBy {
      ...UserActivity
    }
    updatedBy {
      ...UserActivity
    }
    ...CodeGroups
    occurrence @client
  }
  recentCodeIds @client
  memos {
    ...MemoDefault
  }
  codeFolders {
    ...FolderDefault
  }
  sourceFolders {
    ...FolderDefault
  }
  memoFolders {
    ...FolderDefault
  }
  reportFolders {
    ...FolderDefault
  }
  codeGroups {
    ...GroupDefault
    contents {
      ... on Code {
        id
        parent {
          id
          name
        }
        name @client
        comment @client
        color @client
        occurrence @client
      }
    }
  }
  sourceGroups {
    ...GroupDefault
    contents {
      ... on Source {
        id
        name @client
        comment @client
      }
    }
  }
  memoGroups {
    ...GroupDefault
    contents {
      ... on Memo {
        id
        name @client
        comment @client
      }
    }
  }
  reports {
    ...ReportDefault
  }
  ...ProjectInvitations
  activeTeamMemberCount: teamMemberCount(status: "ACTIVE")
  activeTeamMembers: teamMembers(status: "ACTIVE") {
    id
    user {
      ...UserInTeam
    }
    lastActiveAt
  }
  importedTeamMembers: teamMembers(status: "IMPORTED") {
    id
    user {
      ...UserInTeam
    }
    lastActiveAt
  }
  leftTeamMembers: teamMembers(status: "LEFT") {
    id
    user {
      ...UserInTeam
    }
    lastActiveAt
  }
  importedColors {
    id
    name
    rgb
  }
  isImported
  activeAiCoding: aiCodingJobs(status: "IN_PROGRESS") {
    aiCodingId
  }
  recentlyCompletedAiCoding: aiCodingJobs(status: "COMPLETE") {
    aiCodingId
  }
}
    ${UserInTeamFragmentDoc}
${SourceDefaultFragmentDoc}
${CodeDefaultFragmentDoc}
${QuotationDefaultFragmentDoc}
${GroupDefaultFragmentDoc}
${UserActivityFragmentDoc}
${CodeGroupsFragmentDoc}
${MemoDefaultFragmentDoc}
${FolderDefaultFragmentDoc}
${ReportDefaultFragmentDoc}
${ProjectInvitationsFragmentDoc}`;
export const ProjectFullIdsFragmentDoc = gql`
    fragment ProjectFullIds on Project {
  id
  sources {
    id
    quotations {
      id
      codes {
        code {
          id
        }
      }
    }
    pdfPages(offset: 0, limit: 20)
    file {
      id
      key
      location
    }
    fileLocation
    embeddedFiles {
      file {
        id
        key
        location
      }
    }
    groups {
      id
    }
    folder {
      id
    }
  }
  codes {
    id
    groups {
      id
    }
    folder {
      id
    }
  }
  memos {
    id
    embeddedFiles {
      file {
        id
        key
        location
      }
    }
    groups {
      id
    }
    folder {
      id
    }
  }
  codeGroups {
    id
  }
  sourceGroups {
    id
  }
  memoGroups {
    id
  }
  reports {
    id
    folder {
      id
    }
  }
  invitations {
    id
  }
  activeTeamMembers: teamMembers(status: "ACTIVE") {
    id
  }
  leftTeamMembers: teamMembers(status: "LEFT") {
    id
  }
  importedColors {
    id
  }
}
    `;
export const ProjectOverviewInfoFragmentDoc = gql`
    fragment ProjectOverviewInfo on Project {
  id
  name
  description
  color
  createdAt
  updatedAt
  owner {
    ...UserActivity
  }
  activeTeamMembers: teamMembers(status: "ACTIVE") {
    id
    user {
      ...UserActivity
    }
    lastActiveAt
  }
}
    ${UserActivityFragmentDoc}`;
export const QuotationCodeUpdateFragmentDoc = gql`
    fragment QuotationCodeUpdate on Quotation {
  id
  comment
  name
  createdAt
  createdBy {
    ...UserActivity
  }
  updatedAt
  updatedBy {
    ...UserActivity
  }
  codes {
    quotationId
    attachedAt
    attachedBy {
      ...UserActivity
    }
    code {
      ...CodeDefault
    }
  }
}
    ${UserActivityFragmentDoc}
${CodeDefaultFragmentDoc}`;
export const ScholarResultDefaultFragmentDoc = gql`
    fragment ScholarResultDefault on ScholarResult {
  paperId
  sourceId
  corpusId
  title
  abstract
  tldr
  publicationDate
  year
  referenceCount
  citationCount
  influentialCitationCount
  fieldsOfStudyNormalized
  publicationTypes
  isOpenAccess
  openAccessPdf {
    url
  }
  venue
  authors {
    authorId
    name
  }
  externalIds {
    DOI
    PubMed
  }
}
    `;
export const SourceQuotationUpdateFragmentDoc = gql`
    fragment SourceQuotationUpdate on Source {
  id
  quotations {
    ...QuotationDefault
  }
}
    ${QuotationDefaultFragmentDoc}`;
export const UserBaseFragmentDoc = gql`
    fragment UserBase on User {
  id
  firstname
  lastname
  fullname
  email
  locale
  image
  imageIsGravatar
  createdAt
  confirmedAt
  mayReceiveEmails
  isSupportAgent
  helpscoutHashes {
    default
    es
  }
}
    `;
export const UserForExportFragmentDoc = gql`
    fragment UserForExport on User {
  uuid
  firstname
  lastname
}
    `;
export const AcceptInviteToProjectDocument = gql`
    mutation AcceptInviteToProject($inviteToken: String, $projectId: ID, $lookupType: AcceptProjectInviteLookup!) {
  acceptInviteToProject(
    inviteToken: $inviteToken
    projectId: $projectId
    lookupType: $lookupType
  ) {
    ...ProjectOverviewInfo
  }
}
    ${ProjectOverviewInfoFragmentDoc}`;
export const AddChildToCodeDocument = gql`
    mutation AddChildToCode($parentId: String!, $childId: String!) {
  addChildToCode(parentId: $parentId, childId: $childId) {
    parent {
      id
      name
      comment
      color
      createdAt
      createdBy {
        ...UserActivity
      }
      updatedAt
      updatedBy {
        ...UserActivity
      }
      groups {
        id
        name
      }
      isCategory
      parent {
        id
      }
      folder {
        id
      }
    }
    child {
      id
      name
      fullname
      comment
      color
      createdAt
      createdBy {
        ...UserActivity
      }
      updatedAt
      updatedBy {
        ...UserActivity
      }
      groups {
        id
        name
      }
      isCategory
      parent {
        id
      }
      folder {
        id
      }
    }
  }
}
    ${UserActivityFragmentDoc}`;
export const AddCodeToFolderDocument = gql`
    mutation AddCodeToFolder($id: ID!, $folderId: ID!) {
  addToFolder(entityType: code, entityId: $id, folderId: $folderId) {
    id
    name
  }
}
    `;
export const AddCodeToGroupDocument = gql`
    mutation AddCodeToGroup($id: ID!, $groupId: ID!) {
  addToGroup(entityType: code, entityId: $id, groupId: $groupId) {
    id
    name
  }
}
    `;
export const AddCodeToQuotationDocument = gql`
    mutation AddCodeToQuotation($codeId: ID!, $quotationId: ID!) {
  addCodeToQuotation(codeId: $codeId, quotationId: $quotationId) {
    quotationId
    attachedAt
    attachedBy {
      ...UserActivity
    }
    code {
      ...CodeDefault
    }
  }
}
    ${UserActivityFragmentDoc}
${CodeDefaultFragmentDoc}`;
export const AddCodesToQuotationDocument = gql`
    mutation AddCodesToQuotation($codeIds: [ID!], $quotationId: ID!) {
  addCodesToQuotation(codeIds: $codeIds, quotationId: $quotationId) {
    quotationId
    attachedAt
    attachedBy {
      ...UserActivity
    }
    code {
      ...CodeDefault
    }
  }
}
    ${UserActivityFragmentDoc}
${CodeDefaultFragmentDoc}`;
export const AddEmbeddedFileToMemoDocument = gql`
    mutation AddEmbeddedFileToMemo($id: ID!, $file: Upload) {
  addEmbeddedFileToMemo(id: $id, file: $file) {
    id
    key
    location
  }
}
    `;
export const AddEmbeddedFileToSourceDocument = gql`
    mutation AddEmbeddedFileToSource($id: ID!, $file: Upload) {
  addEmbeddedFileToSource(id: $id, file: $file) {
    id
    key
    location
  }
}
    `;
export const AddMemoToFolderDocument = gql`
    mutation AddMemoToFolder($id: ID!, $folderId: ID!) {
  addToFolder(entityType: memo, entityId: $id, folderId: $folderId) {
    id
    name
  }
}
    `;
export const AddMemoToGroupDocument = gql`
    mutation AddMemoToGroup($id: ID!, $groupId: ID!) {
  addToGroup(entityType: memo, entityId: $id, groupId: $groupId) {
    ...GroupDefault
  }
}
    ${GroupDefaultFragmentDoc}`;
export const AddReportToFolderDocument = gql`
    mutation AddReportToFolder($id: ID!, $folderId: ID!) {
  addToFolder(entityType: report, entityId: $id, folderId: $folderId) {
    id
    name
  }
}
    `;
export const AddSourceToFolderDocument = gql`
    mutation AddSourceToFolder($id: ID!, $folderId: ID!) {
  addToFolder(entityType: source, entityId: $id, folderId: $folderId) {
    id
    name
  }
}
    `;
export const AddSourceToGroupDocument = gql`
    mutation AddSourceToGroup($id: ID!, $groupId: ID!) {
  addToGroup(entityType: source, entityId: $id, groupId: $groupId) {
    id
    name
  }
}
    `;
export const AddChildFolderToFolderDocument = gql`
    mutation AddChildFolderToFolder($id: ID!, $parentId: ID!) {
  addChildFolderToFolder(folderId: $id, parentId: $parentId) {
    id
    name
  }
}
    `;
export const AuthenticateDocument = gql`
    mutation Authenticate($email: String!, $firstname: String!, $lastname: String!, $mayReceiveEmails: Boolean!, $locale: String) {
  authenticate(
    email: $email
    firstname: $firstname
    lastname: $lastname
    mayReceiveEmails: $mayReceiveEmails
    locale: $locale
  ) {
    user {
      ...UserBase
    }
    status
  }
}
    ${UserBaseFragmentDoc}`;
export const CancelAiCodingDocument = gql`
    mutation CancelAiCoding($projectId: ID!, $aiCodingId: ID!) {
  cancelAiCoding(projectId: $projectId, aiCodingId: $aiCodingId) {
    aiCodingId
  }
}
    `;
export const ConceptAnalysisV2Document = gql`
    query ConceptAnalysisV2($projectId: ID!, $codeIds: [ID!], $codeGroupIds: [ID!], $sourceIds: [ID!], $sourceGroupIds: [ID!]) {
  conceptAnalysisV2(
    projectId: $projectId
    codeIds: $codeIds
    codeGroupIds: $codeGroupIds
    sourceIds: $sourceIds
    sourceGroupIds: $sourceGroupIds
  ) {
    conceptAnalysisId
  }
}
    `;
export const CreateCodeDocument = gql`
    mutation CreateCode($projectId: ID!, $name: String!, $comment: String, $color: String, $groups: [String]) {
  createCode(
    projectId: $projectId
    name: $name
    comment: $comment
    color: $color
    groups: $groups
  ) {
    ...CodeDefault
    createdAt
    createdBy {
      ...UserActivity
    }
    updatedAt
    updatedBy {
      ...UserActivity
    }
    groups {
      ...GroupDefault
    }
    isCategory
    parent {
      id
      name
    }
  }
}
    ${CodeDefaultFragmentDoc}
${UserActivityFragmentDoc}
${GroupDefaultFragmentDoc}`;
export const CreateFolderDocument = gql`
    mutation CreateFolder($projectId: ID!, $name: String!, $type: String!, $parent: ID, $comment: String, $color: String) {
  createFolder(
    projectId: $projectId
    name: $name
    type: $type
    parent: $parent
    comment: $comment
    color: $color
  ) {
    ...FolderDefault
  }
}
    ${FolderDefaultFragmentDoc}`;
export const CreateGroupDocument = gql`
    mutation CreateGroup($projectId: ID!, $type: GroupContentType!, $name: String!, $comment: String) {
  createGroup(projectId: $projectId, type: $type, name: $name, comment: $comment) {
    ...GroupDefault
    ...GroupContents
  }
}
    ${GroupDefaultFragmentDoc}
${GroupContentsFragmentDoc}`;
export const CreateImportProjectPresignedUrlDocument = gql`
    mutation CreateImportProjectPresignedUrl($fileName: String!, $fileType: String!) {
  createImportProjectPresignedUrl(fileName: $fileName, fileType: $fileType) {
    presignedPost {
      fields {
        key
        bucket
        xAmzAlgorithm
        xAmzCredential
        xAmzDate
        policy
        xAmzSignature
      }
      url
    }
    fileKey
    fileLocation
  }
}
    `;
export const CreateMemoDocument = gql`
    mutation CreateMemo($projectId: ID!, $name: String, $content: String) {
  createMemo(projectId: $projectId, name: $name, content: $content) {
    ...MemoDefault
  }
}
    ${MemoDefaultFragmentDoc}`;
export const CreateOrUpdateQuotationsDocument = gql`
    mutation CreateOrUpdateQuotations($projectId: ID!, $codes: [CreateOrUpdateCodeInput!]!, $parentCodes: [CreateOrUpdateCodeInput!]!, $quotations: [CreateOrUpdateQuotationInput!]!) {
  createOrUpdateQuotations(
    projectId: $projectId
    quotations: $quotations
    codes: $codes
    parentCodes: $parentCodes
  ) {
    codes {
      ...CodeDefault
      createdAt
      createdBy {
        ...UserActivity
      }
      updatedAt
      updatedBy {
        ...UserActivity
      }
      groups {
        ...GroupDefault
      }
      parent {
        id
        name
      }
    }
    parentCodes {
      ...CodeDefault
      createdAt
      createdBy {
        ...UserActivity
      }
      updatedAt
      updatedBy {
        ...UserActivity
      }
      groups {
        ...GroupDefault
      }
      parent {
        id
        name
      }
    }
    quotations {
      sourceId
      deletedAt
      ...QuotationDefault
    }
  }
}
    ${CodeDefaultFragmentDoc}
${UserActivityFragmentDoc}
${GroupDefaultFragmentDoc}
${QuotationDefaultFragmentDoc}`;
export const CreateProjectDocument = gql`
    mutation CreateProject($name: String!, $description: String, $color: String) {
  createProject(name: $name, description: $description, color: $color) {
    ...ProjectOverviewInfo
  }
}
    ${ProjectOverviewInfoFragmentDoc}`;
export const CreateProjectExportDocument = gql`
    mutation CreateProjectExport($id: ID!, $options: ExportOptions) {
  createProjectExport(id: $id, options: $options) {
    id
  }
}
    `;
export const CreateProjectFromTemplateDocument = gql`
    mutation CreateProjectFromTemplate($json: String!) {
  createProjectFromTemplate(json: $json) {
    id
    name
    description
    color
    createdAt
    codeCount
    activeTeamMembers: teamMembers(status: "ACTIVE") {
      id
      user {
        ...UserInTeam
      }
      lastActiveAt
    }
    owner {
      ...UserInTeam
    }
    memoCount
    quotationCount
    sourceCount
    updatedAt
  }
}
    ${UserInTeamFragmentDoc}`;
export const CreateQuotationDocument = gql`
    mutation CreateQuotation($sourceId: ID!, $name: String!, $from: Int!, $to: Int!, $comment: String, $containsImage: Boolean) {
  createQuotation(
    sourceId: $sourceId
    name: $name
    from: $from
    to: $to
    comment: $comment
    containsImage: $containsImage
  ) {
    id
    name
    from
    to
    comment
    containsImage
    deletedAt
    createdAt
    createdBy {
      ...UserActivity
    }
    updatedAt
    updatedBy {
      ...UserActivity
    }
    codeCount
    codes {
      attachedAt
      attachedBy {
        ...UserActivity
      }
      code {
        id
        name
        color
      }
    }
  }
}
    ${UserActivityFragmentDoc}`;
export const CreateQuotationsDocument = gql`
    mutation CreateQuotations($quotations: [QuotationInput!]!) {
  createQuotations(quotations: $quotations) {
    sourceId
    id
    name
    from
    to
    comment
    containsImage
    deletedAt
    createdAt
    createdBy {
      ...UserActivity
    }
    updatedAt
    updatedBy {
      ...UserActivity
    }
    codeCount
    codes {
      attachedAt
      attachedBy {
        ...UserActivity
      }
      code {
        id
        name
        color
      }
    }
  }
}
    ${UserActivityFragmentDoc}`;
export const CreateReportDocument = gql`
    mutation CreateReport($projectId: ID!, $type: String, $name: String, $comment: String, $settings: String) {
  createReport(
    projectId: $projectId
    type: $type
    name: $name
    comment: $comment
    settings: $settings
  ) {
    ...ReportDefault
  }
}
    ${ReportDefaultFragmentDoc}`;
export const CreateSourceDocument = gql`
    mutation CreateSource($projectId: ID!, $name: String, $content: String, $file: Upload) {
  createSource(projectId: $projectId, name: $name, content: $content, file: $file) {
    ...SourceDefault
  }
}
    ${SourceDefaultFragmentDoc}`;
export const CreateSourcesFromCsvColumnsDocument = gql`
    mutation CreateSourcesFromCsvColumns($projectId: ID!, $file: Upload!, $columnsToIgnore: [String]) {
  createSourcesFromCsvColumns(
    projectId: $projectId
    file: $file
    columnsToIgnore: $columnsToIgnore
  ) {
    batchId
  }
}
    `;
export const CreateSourcesFromCsvRowsDocument = gql`
    mutation CreateSourcesFromCsvRows($projectId: ID!, $file: Upload!, $nameColumn: String) {
  createSourcesFromCsvRows(
    projectId: $projectId
    file: $file
    nameColumn: $nameColumn
  ) {
    batchId
  }
}
    `;
export const DeleteCodeDocument = gql`
    mutation DeleteCode($id: ID!, $options: DeleteCodeOptions) {
  deleteCode(id: $id, options: $options) {
    code {
      id
    }
    deletedChildren {
      id
    }
    movedChildren {
      id
      fullname
      parent {
        id
      }
    }
  }
}
    `;
export const DeleteFolderDocument = gql`
    mutation DeleteFolder($id: ID!) {
  deleteFolder(id: $id) {
    id
  }
}
    `;
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($id: ID!) {
  deleteGroup(id: $id) {
    ...GroupDefault
  }
}
    ${GroupDefaultFragmentDoc}`;
export const DeleteInviteToProjectDocument = gql`
    mutation DeleteInviteToProject($id: ID!, $inviteId: ID!) {
  deleteInviteToProject(id: $id, inviteId: $inviteId) {
    ok
  }
}
    `;
export const DeleteMemoDocument = gql`
    mutation DeleteMemo($id: ID!) {
  deleteMemo(id: $id) {
    id
  }
}
    `;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id) {
    id
  }
}
    `;
export const DeleteProjectPermanentlyDocument = gql`
    mutation DeleteProjectPermanently($id: ID!) {
  deleteProjectPermanently(id: $id) {
    id
  }
}
    `;
export const DeleteQuotationDocument = gql`
    mutation DeleteQuotation($id: ID!) {
  deleteQuotation(id: $id) {
    id
  }
}
    `;
export const DeleteReportDocument = gql`
    mutation DeleteReport($id: ID!) {
  deleteReport(id: $id) {
    id
    name
    comment
    type
    settings
    deletedAt
  }
}
    `;
export const DeleteSourceDocument = gql`
    mutation DeleteSource($id: ID!) {
  deleteSource(id: $id) {
    id
  }
}
    `;
export const DeleteTeamMemberFromProjectDocument = gql`
    mutation DeleteTeamMemberFromProject($id: ID!, $teamMemberId: ID!) {
  deleteTeamMemberFromProject(id: $id, teamMemberId: $teamMemberId) {
    id
    activeTeamMemberCount: teamMemberCount(status: "ACTIVE")
    activeTeamMembers: teamMembers(status: "ACTIVE") {
      id
      user {
        ...UserInTeam
      }
      lastActiveAt
    }
    leftTeamMembers: teamMembers(status: "LEFT") {
      id
      user {
        ...UserInTeam
      }
      lastActiveAt
    }
  }
}
    ${UserInTeamFragmentDoc}`;
export const DeleteUserDocument = gql`
    mutation DeleteUser {
  deleteUser {
    ok
  }
}
    `;
export const DuplicateCodeDocument = gql`
    mutation DuplicateCode($id: ID!) {
  duplicateCode(id: $id) {
    code {
      ...CodeDefault
      createdAt
      createdBy {
        ...UserActivity
      }
      updatedAt
      updatedBy {
        ...UserActivity
      }
      groups {
        ...GroupDefault
      }
    }
    children {
      ...CodeDefault
      createdAt
      createdBy {
        ...UserActivity
      }
      updatedAt
      updatedBy {
        ...UserActivity
      }
      groups {
        ...GroupDefault
      }
    }
  }
}
    ${CodeDefaultFragmentDoc}
${UserActivityFragmentDoc}
${GroupDefaultFragmentDoc}`;
export const DuplicateMemoDocument = gql`
    mutation DuplicateMemo($id: ID!) {
  duplicateMemo(id: $id) {
    ...MemoDefault
    content
    version
  }
}
    ${MemoDefaultFragmentDoc}`;
export const DuplicateReportDocument = gql`
    mutation DuplicateReport($id: ID!) {
  duplicateReport(id: $id) {
    ...ReportDefault
  }
}
    ${ReportDefaultFragmentDoc}`;
export const DuplicateSourceDocument = gql`
    mutation DuplicateSource($id: ID!) {
  duplicateSource(id: $id, keepCodes: false) {
    ...SourceDefault
  }
}
    ${SourceDefaultFragmentDoc}`;
export const DuplicateSourceWithCodesDocument = gql`
    mutation DuplicateSourceWithCodes($id: ID!) {
  duplicateSource(id: $id, keepCodes: true) {
    ...SourceDefault
  }
}
    ${SourceDefaultFragmentDoc}`;
export const ImportPdfFromScholarDocument = gql`
    mutation ImportPdfFromScholar($projectId: ID!, $semanticScholarId: String!) {
  importPdfFromScholar(
    projectId: $projectId
    semanticScholarId: $semanticScholarId
  ) {
    ...SourceDefault
    semanticScholarPaperId
  }
}
    ${SourceDefaultFragmentDoc}`;
export const ImportProjectFromAtlprojDocument = gql`
    mutation ImportProjectFromAtlproj($fileKey: String!, $fileName: String!, $fileLocation: String!) {
  importProjectFromAtlproj(
    fileKey: $fileKey
    fileName: $fileName
    fileLocation: $fileLocation
  ) {
    id
    status
    name
    project {
      id
    }
    knownUsers {
      aprxId
      fullname
      firstname
      lastname
    }
    unknownUsers {
      aprxId
      fullname
    }
  }
}
    `;
export const GlobalSearchIndexDocument = gql`
    mutation GlobalSearchIndex($projectId: ID!) {
  indexSearchableNodes(projectId: $projectId) {
    ok
  }
}
    `;
export const InviteToProjectDocument = gql`
    mutation InviteToProject($id: ID!, $email: String!, $firstname: String, $lastname: String, $message: String) {
  inviteToProject(
    id: $id
    email: $email
    firstname: $firstname
    lastname: $lastname
    message: $message
  ) {
    ...Invitation
  }
}
    ${InvitationFragmentDoc}`;
export const LeaveProjectDocument = gql`
    mutation LeaveProject($id: ID!) {
  leaveProject(id: $id) {
    ok
  }
}
    `;
export const MergeCodesDocument = gql`
    mutation MergeCodes($codeIds: [ID!], $name: String!, $comment: String, $color: String) {
  mergeCodes(codeIds: $codeIds, name: $name, comment: $comment, color: $color) {
    id
    name
    comment
    color
    parent {
      id
    }
    isCategory
    groups {
      id
    }
  }
}
    `;
export const RejectInviteToProjectDocument = gql`
    mutation RejectInviteToProject($id: ID!) {
  rejectInviteToProject(id: $id) {
    ...ProjectOverviewInfo
  }
}
    ${ProjectOverviewInfoFragmentDoc}`;
export const RemoveChildFromCodeDocument = gql`
    mutation RemoveChildFromCode($childId: String!) {
  removeChildFromCode(childId: $childId) {
    parent {
      id
      name
      fullname
      comment
      color
      createdAt
      createdBy {
        ...UserActivity
      }
      updatedAt
      updatedBy {
        ...UserActivity
      }
      groups {
        id
        name
      }
      isCategory
      parent {
        id
      }
    }
    child {
      id
      name
      fullname
      comment
      color
      createdAt
      createdBy {
        ...UserActivity
      }
      updatedAt
      updatedBy {
        ...UserActivity
      }
      groups {
        id
        name
      }
      isCategory
      parent {
        id
      }
    }
  }
}
    ${UserActivityFragmentDoc}`;
export const RemoveCodeFromFolderDocument = gql`
    mutation RemoveCodeFromFolder($id: ID!, $folderId: ID!) {
  removeFromFolder(entityType: code, entityId: $id, folderId: $folderId) {
    id
    name
  }
}
    `;
export const RemoveCodeFromGroupDocument = gql`
    mutation RemoveCodeFromGroup($id: ID!, $groupId: ID!) {
  removeFromGroup(entityType: code, entityId: $id, groupId: $groupId) {
    id
    name
  }
}
    `;
export const RemoveCodeFromQuotationDocument = gql`
    mutation RemoveCodeFromQuotation($codeId: ID!, $quotationId: ID!) {
  removeCodeFromQuotation(codeId: $codeId, quotationId: $quotationId) {
    quotationId
    code {
      ...CodeDefault
    }
  }
}
    ${CodeDefaultFragmentDoc}`;
export const RemoveFromChildrenFoldersDocument = gql`
    mutation RemoveFromChildrenFolders($id: ID!, $parentId: ID!) {
  removeFromChildrenFolders(folderId: $id, parentId: $parentId) {
    id
    name
  }
}
    `;
export const RemoveMemoFromFolderDocument = gql`
    mutation RemoveMemoFromFolder($id: ID!, $folderId: ID!) {
  removeFromFolder(entityType: memo, entityId: $id, folderId: $folderId) {
    id
    name
  }
}
    `;
export const RemoveMemoFromGroupDocument = gql`
    mutation RemoveMemoFromGroup($id: ID!, $groupId: ID!) {
  removeFromGroup(entityType: memo, entityId: $id, groupId: $groupId) {
    id
    name
  }
}
    `;
export const RemoveReportFromFolderDocument = gql`
    mutation RemoveReportFromFolder($id: ID!, $folderId: ID!) {
  removeFromFolder(entityType: report, entityId: $id, folderId: $folderId) {
    id
    name
  }
}
    `;
export const RemoveSourceFromFolderDocument = gql`
    mutation RemoveSourceFromFolder($id: ID!, $folderId: ID!) {
  removeFromFolder(entityType: source, entityId: $id, folderId: $folderId) {
    id
    name
  }
}
    `;
export const RemoveSourceFromGroupDocument = gql`
    mutation RemoveSourceFromGroup($id: ID!, $groupId: ID!) {
  removeFromGroup(entityType: source, entityId: $id, groupId: $groupId) {
    id
    name
  }
}
    `;
export const ResendInviteToProjectDocument = gql`
    mutation ResendInviteToProject($id: ID!, $inviteId: ID!) {
  resendInviteToProject(id: $id, inviteId: $inviteId) {
    ok
  }
}
    `;
export const RestoreCodeDocument = gql`
    mutation RestoreCode($id: ID!, $childrenToAdd: [ID!]) {
  restoreCode(id: $id, childrenToAdd: $childrenToAdd) {
    code {
      ...CodeDefault
      createdAt
      updatedAt
      createdBy {
        ...UserActivity
      }
      updatedBy {
        ...UserActivity
      }
      ...CodeGroups
      occurrence @client
    }
    restoredChildren {
      ...CodeDefault
      createdAt
      updatedAt
      createdBy {
        ...UserActivity
      }
      updatedBy {
        ...UserActivity
      }
      ...CodeGroups
      occurrence @client
    }
    addedChildren {
      id
      parent {
        id
      }
    }
  }
}
    ${CodeDefaultFragmentDoc}
${UserActivityFragmentDoc}
${CodeGroupsFragmentDoc}`;
export const RestoreCodeToQuotationDocument = gql`
    mutation RestoreCodeToQuotation($codeId: ID!, $quotationId: ID!, $attachedAt: String!, $attachedByUserId: ID) {
  restoreCodeToQuotation(
    codeId: $codeId
    quotationId: $quotationId
    attachedAt: $attachedAt
    attachedByUserId: $attachedByUserId
  ) {
    id
    updatedAt
    updatedBy {
      ...UserActivity
    }
  }
}
    ${UserActivityFragmentDoc}`;
export const RestoreFolderDocument = gql`
    mutation RestoreFolder($id: ID!) {
  restoreFolder(id: $id) {
    ...FolderDefault
  }
}
    ${FolderDefaultFragmentDoc}`;
export const RestoreGroupDocument = gql`
    mutation RestoreGroup($id: ID!) {
  restoreGroup(id: $id) {
    ...GroupDefault
    ...GroupContents
  }
}
    ${GroupDefaultFragmentDoc}
${GroupContentsFragmentDoc}`;
export const RestoreMemoDocument = gql`
    mutation RestoreMemo($id: ID!) {
  restoreMemo(id: $id) {
    ...MemoDefault
  }
}
    ${MemoDefaultFragmentDoc}`;
export const RestoreProjectDocument = gql`
    mutation RestoreProject($id: ID!) {
  restoreProject(id: $id) {
    ...ProjectDefault
    ...ProjectOverviewInfo
  }
}
    ${ProjectDefaultFragmentDoc}
${ProjectOverviewInfoFragmentDoc}`;
export const RestoreQuotationDocument = gql`
    mutation RestoreQuotation($id: ID!, $from: Int, $to: Int) {
  restoreQuotation(id: $id, from: $from, to: $to) {
    ...QuotationDefault
  }
}
    ${QuotationDefaultFragmentDoc}`;
export const RestoreReportDocument = gql`
    mutation RestoreReport($id: ID!) {
  restoreReport(id: $id) {
    ...ReportDefault
  }
}
    ${ReportDefaultFragmentDoc}`;
export const RestoreSourceDocument = gql`
    mutation RestoreSource($id: ID!) {
  restoreSource(id: $id) {
    ...SourceDefault
  }
}
    ${SourceDefaultFragmentDoc}`;
export const RunProjectImportWithInvitesDocument = gql`
    mutation RunProjectImportWithInvites($id: ID!, $knownUsersToInvite: [KnownUsersToInvite]!, $unknownUsersToInvite: [UnknownUsersToInvite]!) {
  runProjectImport(
    id: $id
    knownUsersToInvite: $knownUsersToInvite
    unknownUsersToInvite: $unknownUsersToInvite
  ) {
    id
    name
    status
  }
}
    `;
export const RunProjectImportWithoutInvitesDocument = gql`
    mutation RunProjectImportWithoutInvites($id: ID!) {
  runProjectImport(
    id: $id
    skipInvite: true
    knownUsersToInvite: []
    unknownUsersToInvite: []
  ) {
    id
    name
    status
  }
}
    `;
export const SentimentAnalysisDocument = gql`
    query SentimentAnalysis($content: String!, $contentExtent: ContentExtent, $sentiments: [Int!]) {
  sentimentAnalysis(
    content: $content
    contentExtent: $contentExtent
    sentiments: $sentiments
  ) {
    sentimentAnalysisId
  }
}
    `;
export const TransferProjectOwnershipToTeamMemberDocument = gql`
    mutation TransferProjectOwnershipToTeamMember($id: ID!, $teamMemberId: ID!) {
  transferProjectOwnershipToTeamMember(id: $id, teamMemberId: $teamMemberId) {
    ok
  }
}
    `;
export const UpdateCodeDocument = gql`
    mutation UpdateCode($id: ID!, $name: String, $comment: String, $color: String) {
  updateCode(id: $id, name: $name, comment: $comment, color: $color) {
    code {
      ...CodeDefault
      updatedAt
      updatedBy {
        ...UserActivity
      }
    }
    children {
      ...CodeDefault
      updatedAt
      updatedBy {
        ...UserActivity
      }
    }
  }
}
    ${CodeDefaultFragmentDoc}
${UserActivityFragmentDoc}`;
export const UpdateFolderDocument = gql`
    mutation UpdateFolder($id: ID!, $name: String, $comment: String, $color: String) {
  updateFolder(id: $id, name: $name, comment: $comment, color: $color) {
    id
    name
    comment
    color
    updatedAt
    updatedBy {
      ...UserActivity
    }
  }
}
    ${UserActivityFragmentDoc}`;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($id: ID!, $name: String, $comment: String) {
  updateGroup(id: $id, name: $name, comment: $comment) {
    id
    type
    name
    comment
  }
}
    `;
export const UpdateMemoDocument = gql`
    mutation UpdateMemo($id: ID!, $name: String, $comment: String, $bibReference: String) {
  updateMemo(id: $id, name: $name, comment: $comment, bibReference: $bibReference) {
    ...MemoDefault
  }
}
    ${MemoDefaultFragmentDoc}`;
export const UpdateMemoContentDocument = gql`
    mutation UpdateMemoContent($id: ID!, $steps: String!, $version: Int!, $clientID: String!) {
  updateMemoContent(
    id: $id
    steps: $steps
    version: $version
    clientID: $clientID
  ) {
    steps
    clientIDs
  }
}
    `;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $name: String, $description: String, $color: String) {
  updateProject(id: $id, name: $name, description: $description, color: $color) {
    id
    name
    description
    color
  }
}
    `;
export const UpdateProjectSupportAccessDocument = gql`
    mutation UpdateProjectSupportAccess($id: ID!, $allowSupportAccess: Boolean!) {
  updateProject(id: $id, allowSupportAccess: $allowSupportAccess) {
    id
    allowSupportAccess
    ...ProjectInvitations
    activeTeamMemberCount: teamMemberCount(status: "ACTIVE")
    activeTeamMembers: teamMembers(status: "ACTIVE") {
      id
      user {
        ...UserInTeam
      }
      lastActiveAt
    }
  }
}
    ${ProjectInvitationsFragmentDoc}
${UserInTeamFragmentDoc}`;
export const UpdateQuotationDocument = gql`
    mutation UpdateQuotation($id: ID!, $name: String, $comment: String, $from: Int, $to: Int, $containsImage: Boolean) {
  updateQuotation(
    id: $id
    name: $name
    comment: $comment
    from: $from
    to: $to
    containsImage: $containsImage
  ) {
    ...QuotationDefault
  }
}
    ${QuotationDefaultFragmentDoc}`;
export const UpdateReportDocument = gql`
    mutation UpdateReport($id: ID!, $name: String, $comment: String, $settings: String) {
  updateReport(id: $id, name: $name, comment: $comment, settings: $settings) {
    id
    name
    comment
    type
    settings
  }
}
    `;
export const UpdateSourceDocument = gql`
    mutation UpdateSource($id: ID!, $name: String, $comment: String, $bibReference: String) {
  updateSource(
    id: $id
    name: $name
    comment: $comment
    bibReference: $bibReference
  ) {
    id
    name
    comment
    bibReference
  }
}
    `;
export const UpdateSourceContentDocument = gql`
    mutation UpdateSourceContent($id: ID!, $steps: String!, $version: Int!, $clientID: String!) {
  updateSourceContent(
    id: $id
    steps: $steps
    version: $version
    clientID: $clientID
  ) {
    steps
    clientIDs
  }
}
    `;
export const UpdateUserDocument = gql`
    mutation UpdateUser($firstname: String, $lastname: String, $email: String, $locale: String, $mayReceiveEmails: Boolean) {
  updateUser(
    firstname: $firstname
    lastname: $lastname
    email: $email
    locale: $locale
    mayReceiveEmails: $mayReceiveEmails
  ) {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;
export const UpdateUserImageDocument = gql`
    mutation UpdateUserImage($file: Upload) {
  updateUserImage(file: $file) {
    id
    image
  }
}
    `;
export const ActiveUsersBySourceDocument = gql`
    query ActiveUsersBySource($sourceId: ID!) {
  activeUsersBySource(sourceId: $sourceId) {
    id
    firstname
    lastname
    fullname
    email
    locale
    image
    confirmedAt
    mayReceiveEmails
  }
}
    `;
export const AiCodeSuggestionsDocument = gql`
    query AiCodeSuggestions($projectId: ID!, $text: String!) {
  aiCodeSuggestions(projectId: $projectId, text: $text) {
    codes {
      ...AiCodeSuggestionDefault
    }
    parentCodes {
      ...AiCodeSuggestionDefault
    }
  }
}
    ${AiCodeSuggestionDefaultFragmentDoc}`;
export const AiCodingDocument = gql`
    query aiCoding($projectId: ID!, $sourceIds: [ID!], $estimate: AiEstimate, $aiCodingId: ID) {
  aiCoding(
    projectId: $projectId
    sourceIds: $sourceIds
    estimate: $estimate
    aiCodingId: $aiCodingId
  ) {
    aiCodingId
    status
  }
}
    `;
export const AiCodingLocalDocument = gql`
    query aiCodingLocal {
  __typename
  aiCodingCreatedQuotations @client {
    __typename @client
    name @client
  }
  aiCodingCreatedCodes @client {
    __typename @client
    id @client
    name @client
    color @client
    comment @client
    occurrence @client
  }
}
    `;
export const AiEstimateAiCodingDocument = gql`
    query aiEstimateAiCoding($projectId: ID!, $sourceIds: [ID!]) {
  aiEstimateAiCoding(projectId: $projectId, sourceIds: $sourceIds) {
    timeToCompleteInMilliseconds
    tokenCount
    availableTokenCount
  }
}
    `;
export const AiEstimateIntentionalCodingDocument = gql`
    query aiEstimateIntentionalCoding($projectId: ID!, $sourceIds: [ID!], $questions: [AiIntentionalCodingQuestionInput!]) {
  aiEstimateIntentionalCoding(
    projectId: $projectId
    sourceIds: $sourceIds
    questions: $questions
  ) {
    tokenCount
    availableTokenCount
    timeToCompleteInMilliseconds
  }
}
    `;
export const AiGenerateIntentionalCodingQuestionsDocument = gql`
    query aiGenerateIntentionalCodingQuestions($projectId: ID!, $intentionPrompt: String!) {
  aiGenerateIntentionalCodingQuestions(
    projectId: $projectId
    intentionPrompt: $intentionPrompt
  ) {
    aiGenerateIntentionalCodingQuestionsId
    status
  }
}
    `;
export const AiIntentionalCodingDocument = gql`
    query aiIntentionalCoding($projectId: ID!, $sourceIds: [ID!], $questions: [AiIntentionalCodingQuestionInput!], $estimate: AiEstimate) {
  aiIntentionalCoding(
    projectId: $projectId
    sourceIds: $sourceIds
    questions: $questions
    estimate: $estimate
  ) {
    jobId
    status
  }
}
    `;
export const GlobalSearchDocument = gql`
    query GlobalSearch($projectId: ID!, $query: GlobalSearchQueryInput!) {
  globalSearch(projectId: $projectId, query: $query) {
    fragmentTexts {
      from
      sourceId
      text
      to
      sentences {
        from
        to
        exact {
          from
          to
        }
      }
    }
    searchTerm
  }
}
    `;
export const MemoDocument = gql`
    query Memo($id: ID!) {
  memo(id: $id) {
    ...MemoDefault
    content
    version
  }
}
    ${MemoDefaultFragmentDoc}`;
export const MemoChangesDocument = gql`
    query MemoChanges($memoId: ID!, $version: Int!) {
  memoChanges(memoId: $memoId, version: $version) {
    steps
    clientIDs
  }
}
    `;
export const MemoEmbeddedFileDocument = gql`
    query MemoEmbeddedFile($id: ID!, $fileId: ID!) {
  memo(id: $id) {
    id
    embeddedFile(fileId: $fileId) {
      ...FileDefault
    }
  }
}
    ${FileDefaultFragmentDoc}`;
export const MemoMetaDocument = gql`
    query MemoMeta($id: ID!) {
  memo(id: $id) {
    ...MemoDefault
  }
}
    ${MemoDefaultFragmentDoc}`;
export const ProjectDocument = gql`
    query Project($id: ID!) {
  project(id: $id) {
    ...ProjectDefault
  }
}
    ${ProjectDefaultFragmentDoc}`;
export const ProjectExportDocument = gql`
    query ProjectExport($id: ID!) {
  project(id: $id) {
    id
    name
    description
    color
    createdAt
    updatedAt
    uuid
    owner {
      uuid
      firstname
      lastname
    }
    codeGroups {
      id
      uuid
      name
      createdAt
      createdBy {
        uuid
        firstname
        lastname
      }
      updatedAt
      updatedBy {
        uuid
        firstname
        lastname
      }
    }
    sourceGroups {
      id
      uuid
      name
      createdAt
      createdBy {
        uuid
        firstname
        lastname
      }
      updatedAt
      updatedBy {
        uuid
        firstname
        lastname
      }
    }
    memoGroups {
      id
      uuid
      name
      createdAt
      createdBy {
        uuid
        firstname
        lastname
      }
      updatedAt
      updatedBy {
        uuid
        firstname
        lastname
      }
    }
    codes {
      id
      uuid
      name
      color
      createdAt
      createdBy {
        uuid
        firstname
        lastname
      }
      updatedAt
      updatedBy {
        uuid
        firstname
        lastname
      }
      comment
      groups {
        id
      }
    }
    sources {
      uuid
      name
      comment
      content
      createdAt
      createdBy {
        uuid
        firstname
        lastname
      }
      updatedAt
      updatedBy {
        uuid
        firstname
        lastname
      }
      quotations {
        uuid
        comment
        from
        to
        createdAt
        createdBy {
          uuid
          firstname
          lastname
        }
        updatedAt
        updatedBy {
          uuid
          firstname
          lastname
        }
        codes {
          attachedAt
          attachedBy {
            uuid
            firstname
            lastname
          }
          code {
            id
            name
            color
            occurrence
          }
        }
      }
      groups {
        id
      }
    }
    memos {
      uuid
      name
      comment
      content
      createdAt
      createdBy {
        uuid
        firstname
        lastname
      }
      updatedAt
      updatedBy {
        uuid
        firstname
        lastname
      }
      groups {
        id
      }
    }
  }
}
    `;
export const ProjectExportXlsxDocument = gql`
    query ProjectExportXlsx($id: ID!) {
  project(id: $id) {
    id
    name
    sources {
      id
      name
      quotations {
        id
        comment
        name
        codes {
          quotationId
          code {
            id
            name
            fullname
          }
        }
      }
    }
    codes {
      id
      name
      fullname
      color
      comment
      occurrence
      groups {
        id
        name
      }
    }
  }
}
    `;
export const ProjectGroupsDocument = gql`
    query ProjectGroups($id: ID!) {
  project(id: $id) {
    id
    codeGroups {
      ...GroupDefault
      contents {
        ... on Code {
          id
          name @client
          comment @client
          color @client
          occurrence @client
        }
      }
    }
    sourceGroups {
      ...GroupDefault
      contents {
        ... on Source {
          id
          name @client
          comment @client
        }
      }
    }
    memoGroups {
      ...GroupDefault
      contents {
        ... on Memo {
          id
          name @client
          comment @client
        }
      }
    }
  }
}
    ${GroupDefaultFragmentDoc}`;
export const ProjectImportDocument = gql`
    query ProjectImport($id: ID!) {
  projectImport(id: $id) {
    id
    status
    name
    project {
      id
    }
    knownUsers {
      aprxId
      fullname
      firstname
      lastname
    }
    unknownUsers {
      aprxId
      fullname
    }
  }
}
    `;
export const ProjectTemplateDocument = gql`
    query ProjectTemplate($id: ID!) {
  project(id: $id) {
    id
    name
    description
    color
    codes {
      id
      name
      color
      comment
      groups {
        id
      }
    }
    sources {
      name
      comment
      content
      quotations {
        name
        comment
        from
        to
        codes {
          quotationId
          code {
            id
          }
        }
      }
      groups {
        id
      }
    }
    memos {
      name
      comment
      content
      groups {
        id
      }
    }
    sourceGroups {
      id
      name
      comment
      type
    }
    codeGroups {
      id
      name
      comment
      type
    }
    memoGroups {
      id
      name
      comment
      type
    }
  }
}
    `;
export const ProjectWithProjectImportDocument = gql`
    query ProjectWithProjectImport($id: ID!) {
  project(id: $id) {
    id
    name
    isImported
    projectImport {
      name
      fileDownloadUrl
    }
  }
}
    `;
export const ReportDocument = gql`
    query Report($id: ID!) {
  report(id: $id) {
    ...ReportDefault
  }
}
    ${ReportDefaultFragmentDoc}`;
export const ScholarPaperSearchAiSummaryCacheDocument = gql`
    query ScholarPaperSearchAiSummaryCache($projectId: ID!, $search: String!, $filterList: String = "") {
  scholarPaperSearchAiSummary(
    projectId: $projectId
    search: $search
    filterList: $filterList
  ) {
    skip
    limit
    aiSummary {
      conclusion
      references {
        reference
        paperId
      }
      keyInsights {
        title
        points
      }
    }
    emptyAiSummaryReason
    referencedPapers {
      ...ScholarResultDefault
    }
  }
}
    ${ScholarResultDefaultFragmentDoc}`;
export const SourceDocument = gql`
    query Source($id: ID!, $pageLimit: Int = 20) {
  source(id: $id) {
    ...SourceDefault
    fileLocation
    quotations {
      ...QuotationDefault
      codeCount
      deletedAt
    }
    pdfPages(offset: 0, limit: $pageLimit)
    content
    version
    storedPdfPagesCount
    semanticScholarPaperId
  }
}
    ${SourceDefaultFragmentDoc}
${QuotationDefaultFragmentDoc}`;
export const SourceChangesDocument = gql`
    query SourceChanges($sourceId: ID!, $version: Int!) {
  sourceChanges(sourceId: $sourceId, version: $version) {
    steps
    clientIDs
    quotations {
      ...QuotationDefault
      codeCount
      deletedAt
    }
  }
}
    ${QuotationDefaultFragmentDoc}`;
export const SourceEmbeddedFileDocument = gql`
    query SourceEmbeddedFile($id: ID!, $fileId: ID!) {
  source(id: $id) {
    id
    embeddedFile(fileId: $fileId) {
      ...FileDefault
    }
  }
}
    ${FileDefaultFragmentDoc}`;
export const SourcePdfPagesDocument = gql`
    query SourcePdfPages($sourceId: ID!, $offset: Int, $limit: Int) {
  source(id: $sourceId) {
    id
    pdfPages(offset: $offset, limit: $limit)
  }
}
    `;
export const SourcePdfPlutDocument = gql`
    query SourcePdfPlut($sourceId: ID!) {
  source(id: $sourceId) {
    id
    plutFile {
      id
      location
    }
  }
}
    `;
export const SourceQuotationsDocument = gql`
    query SourceQuotations($id: ID!) {
  source(id: $id) {
    id
    quotations {
      ...QuotationDefault
      codeCount
      deletedAt
    }
  }
}
    ${QuotationDefaultFragmentDoc}`;
export const TestTemplateDocument = gql`
    query TestTemplate($projectId: ID!, $teamMemberStatus: String) {
  testTemplate(projectId: $projectId) {
    id
    firstname
    lastname
    email
    locale
    createdAt
    updatedAt
    projectsJoined {
      id
    }
    projects {
      id
      name
      description
      color
      codes {
        id
        name
        color
        comment
        groups {
          id
        }
      }
      sources {
        id
        name
        comment
        content
        lastOpenedAt
        createdAt
        createdBy {
          id
        }
        updatedAt
        updatedBy {
          id
        }
        quotations {
          id
          name
          comment
          from
          to
          codes {
            quotationId
            attachedAt
            attachedBy {
              id
            }
            code {
              id
            }
          }
          createdBy {
            id
          }
          updatedBy {
            id
          }
          createdAt
          updatedAt
        }
        groups {
          id
        }
        fileLocation
        fileType
        pdfPages(offset: 0, limit: 100)
      }
      memos {
        name
        comment
        content
        groups {
          id
        }
      }
      sourceGroups {
        id
        name
        comment
        type
      }
      codeGroups {
        id
        name
        comment
        type
      }
      memoGroups {
        id
        name
        comment
        type
      }
      reports {
        id
        name
        type
        comment
        settings
      }
      invitations {
        firstname
        lastname
        user {
          id
        }
        email
        message
        status
        createdAt
        updatedAt
        rejectedAt
        deletedAt
        createdBy {
          id
        }
        updatedBy {
          id
        }
        deletedBy {
          id
        }
      }
      teamMembers(status: $teamMemberStatus) {
        status
        user {
          id
        }
        createdAt
        updatedAt
        deletedAt
        leftAt
        lastActiveAt
        createdBy {
          id
        }
        deactivatedBy {
          id
        }
        updatedBy {
          id
        }
        deletedBy {
          id
        }
      }
    }
  }
}
    `;
export const UserDocument = gql`
    query User {
  user {
    ...UserBase
  }
}
    ${UserBaseFragmentDoc}`;
export const UserFullIdsDocument = gql`
    query UserFullIds {
  user {
    id
    projects {
      ...ProjectFullIds
    }
    projectsJoined {
      ...ProjectFullIds
    }
    projectsInvited {
      ...ProjectFullIds
    }
  }
}
    ${ProjectFullIdsFragmentDoc}`;
export const UserProjectsDocument = gql`
    query UserProjects {
  user {
    id
    projects {
      ...ProjectOverviewInfo
    }
    projectsJoined {
      ...ProjectOverviewInfo
    }
    projectsInvited {
      ...ProjectOverviewInfo
    }
  }
}
    ${ProjectOverviewInfoFragmentDoc}`;
export const WordDocument = gql`
    query Word($name: String!) {
  word(name: $name) {
    name
    synonyms {
      name
      category
    }
  }
}
    `;
export const ScholarCitationDocument = gql`
    query ScholarCitation($semanticScholarId: String!) {
  scholarCitation(semanticScholarId: $semanticScholarId) {
    formats {
      name
      html
    }
  }
}
    `;
export const ScholarPaperConclusionDocument = gql`
    query ScholarPaperConclusion($projectId: ID!, $researchQuestion: String!, $paperId: String!, $abstract: String!) {
  scholarPaperConclusion(
    projectId: $projectId
    researchQuestion: $researchQuestion
    paperId: $paperId
    abstract: $abstract
  ) {
    paperConclusion
  }
}
    `;
export const ScholarPaperSearchDocument = gql`
    query ScholarPaperSearch($projectId: ID!, $search: String!, $skip: Int = 0, $limit: Int = 25, $filterList: String = "", $createAiSummary: Boolean = true) {
  scholarPaperSearch(
    projectId: $projectId
    search: $search
    skip: $skip
    limit: $limit
    filterList: $filterList
    createAiSummary: $createAiSummary
  ) {
    hasMore
    total
    results {
      ...ScholarResultDefault
    }
  }
}
    ${ScholarResultDefaultFragmentDoc}`;
export const AiCodingProgressDocument = gql`
    subscription aiCodingProgress($aiCodingId: ID!) {
  aiCodingProgress(aiCodingId: $aiCodingId) {
    aiCodingId
    projectId
    status
    progressPercent
    codes {
      ...AiCodingCodeDefault
    }
    parentCodes {
      ...AiCodingCodeDefault
    }
    quotations {
      ...AiCodingQuotationDefault
    }
  }
}
    ${AiCodingCodeDefaultFragmentDoc}
${AiCodingQuotationDefaultFragmentDoc}`;
export const AiGenerateIntentionalCodingQuestionsProgressDocument = gql`
    subscription aiGenerateIntentionalCodingQuestionsProgress($id: ID!) {
  aiGenerateIntentionalCodingQuestionsProgress(id: $id) {
    id
    progressPercent
    status
    preparedQuestions
    questions {
      title
      content
      code {
        ...AiCodingCodeDefault
      }
    }
  }
}
    ${AiCodingCodeDefaultFragmentDoc}`;
export const AiIntentionalCodingProgressDocument = gql`
    subscription aiIntentionalCodingProgress($id: ID!) {
  aiIntentionalCodingProgress(id: $id) {
    jobId
    projectId
    status
    progressPercent
    codes {
      ...AiCodingCodeDefault
    }
    parentCodes {
      ...AiCodingCodeDefault
    }
    quotations {
      ...AiCodingQuotationDefault
    }
  }
}
    ${AiCodingCodeDefaultFragmentDoc}
${AiCodingQuotationDefaultFragmentDoc}`;
export const ConceptAnalysisProgressDocument = gql`
    subscription ConceptAnalysisProgress($conceptAnalysisId: ID!) {
  conceptAnalysisProgress(conceptAnalysisId: $conceptAnalysisId) {
    conceptAnalysisId
    projectId
    status
    progressPercent
    concepts {
      concept
      count
      matches {
        match
        count
        locations {
          document
          text
          range {
            start
            length
          }
        }
      }
    }
  }
}
    `;
export const CreateSourcesCsvProgressDocument = gql`
    subscription createSourcesCsvProgress($projectId: ID!, $batchId: String!) {
  createSourcesCsvProgress(projectId: $projectId, batchId: $batchId) {
    batchId
    projectId
    status
    current
    total
  }
}
    `;
export const ProjectCreatedDocument = gql`
    subscription projectCreated {
  projectCreated {
    ...ProjectOverviewInfo
  }
}
    ${ProjectOverviewInfoFragmentDoc}`;
export const ProjectExportProgressDocument = gql`
    subscription projectExportProgress($id: ID!) {
  projectExportProgress(id: $id) {
    id
    projectId
    status
    exportLocation
    fileName
    current
    total
  }
}
    `;
export const ProjectImportProgressDocument = gql`
    subscription projectImportProgress($id: ID!) {
  projectImportProgress(id: $id) {
    id
    projectId
    status
    current
    total
  }
}
    `;
export const ScholarPaperSearchAiSummaryDocument = gql`
    subscription scholarPaperSearchAiSummary($projectId: ID!, $search: String!, $filterList: String = "") {
  scholarPaperSearchAiSummary(
    projectId: $projectId
    search: $search
    filterList: $filterList
  ) {
    skip
    limit
    aiSummary {
      conclusion
      references {
        reference
        paperId
      }
      keyInsights {
        title
        points
      }
    }
    emptyAiSummaryReason
    referencedPapers {
      ...ScholarResultDefault
    }
  }
}
    ${ScholarResultDefaultFragmentDoc}`;
export const SentimentAnalysisProgressDocument = gql`
    subscription SentimentAnalysisProgress($sentimentAnalysisId: ID!) {
  sentimentAnalysisProgress(sentimentAnalysisId: $sentimentAnalysisId) {
    sentimentAnalysisId
    status
    progressPercent
    locations {
      range {
        start
        length
      }
      analysis {
        language
        sentiment
      }
    }
  }
}
    `;
export const SourcesCreatedDocument = gql`
    subscription sourcesCreated($projectId: ID!) {
  sourcesCreated(projectId: $projectId) {
    ...SourceDefault
  }
}
    ${SourceDefaultFragmentDoc}`;